/* tslint:disable */
/* eslint-disable */
/**
 * reniecytMs
 * API para el microservicio reniecyt
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Clase que representa la actulizacion de una sede con información de sede y sector.
 * @export
 * @interface ActualizaRegistro
 */
export interface ActualizaRegistro {
    /**
     * 
     * @type {Registro}
     * @memberof ActualizaRegistro
     */
    'registro'?: Registro;
    /**
     * 
     * @type {Sector}
     * @memberof ActualizaRegistro
     */
    'sector'?: Sector;
}
/**
 * 
 * @export
 * @interface AnotacionesIncumplimiento
 */
export interface AnotacionesIncumplimiento {
    /**
     * Identificador único del Registro.
     * @type {number}
     * @memberof AnotacionesIncumplimiento
     */
    'id'?: number;
    /**
     * Nombre de la unidad administrativa.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'unidadAdministrativa'?: string;
    /**
     * Nombre del funcionario solicitante.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'funcionarioSolicitante'?: string;
    /**
     * Fecha de solicitud.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'fechaSolicitud'?: string;
    /**
     * Número de oficio.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'numeroOficio'?: string;
    /**
     * 
     * @type {Plataforma}
     * @memberof AnotacionesIncumplimiento
     */
    'plataforma'?: Plataforma;
    /**
     * 
     * @type {Subsistema}
     * @memberof AnotacionesIncumplimiento
     */
    'subsistema'?: Subsistema;
    /**
     * .
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'anio'?: string;
    /**
     * Número de apoyo.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'numeroApoyo'?: string;
    /**
     * Nombre del participante de la convocatoria.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'convocatoriaParticipante'?: string;
    /**
     * Número de perfil único.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'numeroCvu'?: string;
    /**
     * Número de registro.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'numeroRegistro'?: string;
    /**
     * 
     * @type {TipoUsuario}
     * @memberof AnotacionesIncumplimiento
     */
    'tipoUsuario'?: TipoUsuario;
    /**
     * Descripción del registro.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'descripcion'?: string;
    /**
     * Número de folio.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'numeroFolio'?: string;
    /**
     * Nombre del usuario.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'nombre'?: string;
    /**
     * Primer apellido del usuario.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'primerApellido'?: string;
    /**
     * Segundo apellido del usuario.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'segundoApellido'?: string;
    /**
     * Nombre del usuario que registra la anotación.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'nombreOperador'?: string;
    /**
     * Primer apellido del usuario que registra la anotación.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'primerApellidoOperador'?: string;
    /**
     * Segundo apellido del usuario que registra la anotación.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'segundoApellidoOperador'?: string;
    /**
     * 
     * @type {RegistroCancelacionIncumplimiento}
     * @memberof AnotacionesIncumplimiento
     */
    'registroCancelacionIncumplimiento'?: RegistroCancelacionIncumplimiento;
    /**
     * RFC del registro.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'rfc'?: string;
    /**
     * Razón social del registro.
     * @type {string}
     * @memberof AnotacionesIncumplimiento
     */
    'razonSocial'?: string;
}
/**
 * 
 * @export
 * @interface AreaConocimientoReniecyt
 */
export interface AreaConocimientoReniecyt {
    /**
     * 
     * @type {string}
     * @memberof AreaConocimientoReniecyt
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof AreaConocimientoReniecyt
     */
    'campo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AreaConocimientoReniecyt
     */
    'disciplina'?: string;
    /**
     * 
     * @type {string}
     * @memberof AreaConocimientoReniecyt
     */
    'subdisciplina'?: string;
}
/**
 * 
 * @export
 * @interface ComentarioPersonaRegistro
 */
export interface ComentarioPersonaRegistro {
    /**
     * Identificador único del comentario
     * @type {number}
     * @memberof ComentarioPersonaRegistro
     */
    'id'?: number;
    /**
     * El id de la persona asociado a este comentario
     * @type {number}
     * @memberof ComentarioPersonaRegistro
     */
    'personaRegistroId'?: number;
    /**
     * El texto del comentario
     * @type {string}
     * @memberof ComentarioPersonaRegistro
     */
    'comentario'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComentarioPersonaRegistro
     */
    'fecha'?: string;
    /**
     * El administrador que creo el comentario
     * @type {string}
     * @memberof ComentarioPersonaRegistro
     */
    'administrador'?: string;
}
/**
 * 
 * @export
 * @interface ComentarioRechazo
 */
export interface ComentarioRechazo {
    /**
     * Comentario detallado del motivo del rechazo.
     * @type {string}
     * @memberof ComentarioRechazo
     */
    'comentario'?: string;
}
/**
 * 
 * @export
 * @interface ComentarioRechazoSolicitud
 */
export interface ComentarioRechazoSolicitud {
    /**
     * Comentario detallado del motivo del rechazo.
     * @type {string}
     * @memberof ComentarioRechazoSolicitud
     */
    'comentario'?: string;
}
/**
 * 
 * @export
 * @interface ComentarioRegistroEstatus
 */
export interface ComentarioRegistroEstatus {
    /**
     * Identificador único del comentario
     * @type {number}
     * @memberof ComentarioRegistroEstatus
     */
    'id'?: number;
    /**
     * El id del estado del registro asociado a este comentario
     * @type {number}
     * @memberof ComentarioRegistroEstatus
     */
    'registroEstatusId'?: number;
    /**
     * El texto del comentario
     * @type {string}
     * @memberof ComentarioRegistroEstatus
     */
    'comentario'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComentarioRegistroEstatus
     */
    'fecha'?: string;
    /**
     * El revisor que creo el comentario
     * @type {string}
     * @memberof ComentarioRegistroEstatus
     */
    'revisor'?: string;
}
/**
 * Clase que representa un registro con información de registro, persona, sector y el estado.
 * @export
 * @interface ConsultaRegistro
 */
export interface ConsultaRegistro {
    /**
     * 
     * @type {Registro}
     * @memberof ConsultaRegistro
     */
    'registro'?: Registro;
    /**
     * 
     * @type {Persona}
     * @memberof ConsultaRegistro
     */
    'persona'?: Persona;
    /**
     * 
     * @type {Sector}
     * @memberof ConsultaRegistro
     */
    'sector'?: Sector;
    /**
     * 
     * @type {EstatusRegistro}
     * @memberof ConsultaRegistro
     */
    'estatusRegistro'?: EstatusRegistro;
}
/**
 * 
 * @export
 * @interface ConsultaRegistroAllOf
 */
export interface ConsultaRegistroAllOf {
    /**
     * 
     * @type {EstatusRegistro}
     * @memberof ConsultaRegistroAllOf
     */
    'estatusRegistro'?: EstatusRegistro;
}
/**
 * 
 * @export
 * @interface DatosEliminacionSubsede
 */
export interface DatosEliminacionSubsede {
    /**
     * Identificador único
     * @type {number}
     * @memberof DatosEliminacionSubsede
     */
    'id'?: number;
    /**
     * ID del registro
     * @type {number}
     * @memberof DatosEliminacionSubsede
     */
    'idRegistro'?: number;
    /**
     * Comentario
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'comentario'?: string;
    /**
     * Nombre del documento
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'nombreDocumento'?: string;
    /**
     * Url del documento
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'urlDocumento'?: string;
    /**
     * Nombre del segundo documento
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'nombreDocumentoDos'?: string;
    /**
     * Url del segundo documento
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'urlDocumentoDos'?: string;
    /**
     * Nombre del usuario que realiza la eliminación
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'nombreUsuario'?: string;
    /**
     * CVU del usuario que realiza la eliminación
     * @type {string}
     * @memberof DatosEliminacionSubsede
     */
    'cvuUsuario'?: string;
    /**
     * Indicador para saber si esAdmin
     * @type {boolean}
     * @memberof DatosEliminacionSubsede
     */
    'esAdmin'?: boolean;
}
/**
 * 
 * @export
 * @interface DatosSedeHistorico
 */
export interface DatosSedeHistorico {
    /**
     * Identificador único.
     * @type {number}
     * @memberof DatosSedeHistorico
     */
    'id'?: number;
    /**
     * ID del registro
     * @type {number}
     * @memberof DatosSedeHistorico
     */
    'idRegistro'?: number;
    /**
     * RFC anterior.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'rfcAnterior'?: string;
    /**
     * Razón Social anterior.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'razonSocialAnterior'?: string;
    /**
     * RFC nuevo.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'rfcNuevo'?: string;
    /**
     * Razón Social nuevo.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'razonSocialNuevo'?: string;
    /**
     * Comentario de justificacion.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'comentario'?: string;
    /**
     * Nombre del documento.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'nombreDocumento'?: string;
    /**
     * URL del documento.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'urlDocumento'?: string;
    /**
     * Nombre del usuario que realiza la eliminación.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'nombreUsuario'?: string;
    /**
     * CVU del usuario que realiza la eliminación.
     * @type {string}
     * @memberof DatosSedeHistorico
     */
    'cvuUsuario'?: string;
}
/**
 * Informacion de un docuemnto el cual contiene el nombre del documento y la url
 * @export
 * @interface Documento
 */
export interface Documento {
    /**
     * Nombre del archivo
     * @type {string}
     * @memberof Documento
     */
    'nombre'?: string;
    /**
     * URL del archivo
     * @type {string}
     * @memberof Documento
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface DocumentoCancelacionIncumplimiento
 */
export interface DocumentoCancelacionIncumplimiento {
    /**
     * Nombre del archivo relacionado con la cancelación de incumplimiento
     * @type {string}
     * @memberof DocumentoCancelacionIncumplimiento
     */
    'nombreArchivo'?: string;
    /**
     * URL donde se encuentra el archivo
     * @type {string}
     * @memberof DocumentoCancelacionIncumplimiento
     */
    'url'?: string;
    /**
     * Estado de activación del documento
     * @type {boolean}
     * @memberof DocumentoCancelacionIncumplimiento
     */
    'activated'?: boolean;
}
/**
 * Clase que representa informacion del documento de creación.
 * @export
 * @interface DocumentoCreacion
 */
export interface DocumentoCreacion {
    /**
     * Identificador único del documento de creación.
     * @type {number}
     * @memberof DocumentoCreacion
     */
    'id'?: number;
    /**
     * Identificador del registro asociado al documento.
     * @type {number}
     * @memberof DocumentoCreacion
     */
    'registroId'?: number;
    /**
     * Identificador del tipo de documento.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'tipoDocumentoId'?: string;
    /**
     * Nombre del tipo de documento.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'tipoDocumentoNombre'?: string;
    /**
     * Identificador de la entidad.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'entidadId'?: string;
    /**
     * Nombre de la entidad.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'entidadNombre'?: string;
    /**
     * Número de acta.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'numeroActa'?: string;
    /**
     * Fecha del acta.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'fechaActa'?: string;
    /**
     * Nombre del notario.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'nombreNotario'?: string;
    /**
     * Número de notario.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'numeroNotario'?: string;
    /**
     * Folio.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'folio'?: string;
    /**
     * Nombre del documento.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'nombreDocumento'?: string;
    /**
     * URL del documento.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'urlDocumento'?: string;
    /**
     * Puesto del funcionario.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'puestoFuncionario'?: string;
    /**
     * Constitución legal del documento.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'constitucionLegalDocumento'?: string;
    /**
     * Denominación de la ley mexicana.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'denominacionLeyMexicana'?: string;
    /**
     * Razón social del aval.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'razonSocialAval'?: string;
    /**
     * Indica si el documento de creación está activado o desactivado.
     * @type {boolean}
     * @memberof DocumentoCreacion
     */
    'activated'?: boolean;
    /**
     * Folio de constitucion.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'folioConstitucion'?: string;
    /**
     * Folio de propiedad.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'folioPropiedad'?: string;
    /**
     * Nombre del funcionario.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'nombreFuncionario'?: string;
    /**
     * Nombre del fideicomisante.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'nombreFideicomisante'?: string;
    /**
     * Entidad fiduciaria.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'entidadFiduciaria'?: string;
    /**
     * Número de póliza.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'numeroPoliza'?: string;
    /**
     * Nombre del corredor.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'nombreCorredor'?: string;
    /**
     * Número del corredor.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'numeroCorredor'?: string;
    /**
     * Número de registro del aval.
     * @type {string}
     * @memberof DocumentoCreacion
     */
    'numeroRegistroAval'?: string;
}
/**
 * 
 * @export
 * @interface DocumentoCreacionReniecyt
 */
export interface DocumentoCreacionReniecyt {
    /**
     * 
     * @type {string}
     * @memberof DocumentoCreacionReniecyt
     */
    'tipoDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoCreacionReniecyt
     */
    'fechaExpedicion'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoCreacionReniecyt
     */
    'numeroEscritura'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoCreacionReniecyt
     */
    'numeroNotario'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoCreacionReniecyt
     */
    'nombreNotario'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoCreacionReniecyt
     */
    'EntidadFederativa'?: string;
}
/**
 * Documento a exportar en formato PDF  y HTML
 * @export
 * @interface DocumentoExport
 */
export interface DocumentoExport {
    /**
     * MIME type del documento
     * @type {string}
     * @memberof DocumentoExport
     */
    'contentType'?: string;
    /**
     * Contiene el documento en contenidoBase64
     * @type {string}
     * @memberof DocumentoExport
     */
    'contenidoBase64'?: string;
}
/**
 * 
 * @export
 * @interface DocumentoIncumplimiento
 */
export interface DocumentoIncumplimiento {
    /**
     * 
     * @type {AnotacionesIncumplimiento}
     * @memberof DocumentoIncumplimiento
     */
    'idIncumplimiento'?: AnotacionesIncumplimiento;
    /**
     * Nombre del archivo relacionado con la anotación de incumplimiento
     * @type {string}
     * @memberof DocumentoIncumplimiento
     */
    'nombreDocumento'?: string;
    /**
     * URL donde se encuentra el archivo
     * @type {string}
     * @memberof DocumentoIncumplimiento
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface DocumentoReniecyt
 */
export interface DocumentoReniecyt {
    /**
     * 
     * @type {string}
     * @memberof DocumentoReniecyt
     */
    'constanciaSitFiscalNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoReniecyt
     */
    'identificacionOficialNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoReniecyt
     */
    'registroPropPublicaNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentoReniecyt
     */
    'avalNombre'?: string;
}
/**
 * Entidad que representa un registro de documento para un representante.
 * @export
 * @interface DocumentoRepresentante
 */
export interface DocumentoRepresentante {
    /**
     * Identificador único del registro.
     * @type {number}
     * @memberof DocumentoRepresentante
     */
    'id'?: number;
    /**
     * Identificador único de la persona asociada al registro.
     * @type {number}
     * @memberof DocumentoRepresentante
     */
    'personaId'?: number;
    /**
     * Identificador único del registro asociado.
     * @type {number}
     * @memberof DocumentoRepresentante
     */
    'registroId'?: number;
    /**
     * Nombre del archivo de la constancia de situación fiscal.
     * @type {string}
     * @memberof DocumentoRepresentante
     */
    'constanciaSitFiscalNombre'?: string;
    /**
     * URL del archivo de la constancia de situación fiscal.
     * @type {string}
     * @memberof DocumentoRepresentante
     */
    'constanciaSitFiscalUrl'?: string;
    /**
     * Nombre del archivo de la identificación oficial.
     * @type {string}
     * @memberof DocumentoRepresentante
     */
    'identificacionOficialNombre'?: string;
    /**
     * URL del archivo de la identificación oficial.
     * @type {string}
     * @memberof DocumentoRepresentante
     */
    'identificacionOficialUrl'?: string;
    /**
     * Indica si el registro está activo o no.
     * @type {boolean}
     * @memberof DocumentoRepresentante
     */
    'activated'?: boolean;
}
/**
 * Entidad que representa un registro de documento para una sede.
 * @export
 * @interface DocumentoSede
 */
export interface DocumentoSede {
    /**
     * Identificador único del registro.
     * @type {number}
     * @memberof DocumentoSede
     */
    'id'?: number;
    /**
     * Identificador único del registro asociado.
     * @type {number}
     * @memberof DocumentoSede
     */
    'registroId'?: number;
    /**
     * Nombre del archivo de la constancia de situación fiscal.
     * @type {string}
     * @memberof DocumentoSede
     */
    'constanciaSitFiscalNombre'?: string;
    /**
     * URL del archivo de la constancia de situación fiscal.
     * @type {string}
     * @memberof DocumentoSede
     */
    'constanciaSitFiscalUrl'?: string;
    /**
     * Nombre del archivo del registro de propiedad pública.
     * @type {string}
     * @memberof DocumentoSede
     */
    'registroPropPublicaNombre'?: string;
    /**
     * URL del archivo del registro de propiedad pública.
     * @type {string}
     * @memberof DocumentoSede
     */
    'registroPropPublicaUrl'?: string;
    /**
     * Nombre del aval.
     * @type {string}
     * @memberof DocumentoSede
     */
    'avalNombre'?: string;
    /**
     * URL del archivo del aval.
     * @type {string}
     * @memberof DocumentoSede
     */
    'avalUrl'?: string;
    /**
     * Indica si el registro está activo o no.
     * @type {boolean}
     * @memberof DocumentoSede
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentosRepresentante
 */
export interface DocumentosRepresentante {
    /**
     * Nombre del representante legal
     * @type {string}
     * @memberof DocumentosRepresentante
     */
    'nombreRepresentante'?: string;
    /**
     * Lista de documentos de un representante legal
     * @type {Array<Documento>}
     * @memberof DocumentosRepresentante
     */
    'documentos'?: Array<Documento>;
}
/**
 * 
 * @export
 * @interface DocumentosSubsede
 */
export interface DocumentosSubsede {
    /**
     * Identificador de la subsede
     * @type {number}
     * @memberof DocumentosSubsede
     */
    'idSubsede'?: number;
    /**
     * Numero de la subsede
     * @type {string}
     * @memberof DocumentosSubsede
     */
    'noSubsede'?: string;
    /**
     * Lista de documentos de una subsede
     * @type {Array<DocumentosRepresentante>}
     * @memberof DocumentosSubsede
     */
    'documentosRepresentantes'?: Array<DocumentosRepresentante>;
}
/**
 * 
 * @export
 * @interface DomicilioReniecyt
 */
export interface DomicilioReniecyt {
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'cp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'estado'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'municipio'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'localidad'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'calle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'numeroExterior'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'numeroExteriorAnterior'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'numeroInterior'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'numeroExteriorAlfanumerico'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'numeroInteriorAlfanumerico'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'colonia'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'descripcionUbicacion'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'pais'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'asentamientoNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DomicilioReniecyt
     */
    'tipoAsentamientoNombre'?: string;
}
/**
 * 
 * @export
 * @interface EntidadFederativa
 */
export interface EntidadFederativa {
    /**
     * 
     * @type {number}
     * @memberof EntidadFederativa
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntidadFederativa
     */
    'nombre'?: string;
}
/**
 * Estado de un registro
 * @export
 * @interface EstatusRegistro
 */
export interface EstatusRegistro {
    /**
     * ID del estatus
     * @type {number}
     * @memberof EstatusRegistro
     */
    'id'?: number;
    /**
     * Clave del estatus
     * @type {string}
     * @memberof EstatusRegistro
     */
    'clave'?: string;
    /**
     * Nombre del estatus
     * @type {string}
     * @memberof EstatusRegistro
     */
    'nombre'?: string;
}
/**
 * 
 * @export
 * @interface EstatusReniecyt
 */
export interface EstatusReniecyt {
    /**
     * 
     * @type {number}
     * @memberof EstatusReniecyt
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EstatusReniecyt
     */
    'clave'?: string;
    /**
     * 
     * @type {string}
     * @memberof EstatusReniecyt
     */
    'descripcion'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'razonSocial'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'rfc'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'comentario'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'nombreDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'urlDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'nombreUsuario'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'cvuUsuario'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * Comentario detallado del motivo de la eliminacion.
     * @type {string}
     * @memberof InlineObject1
     */
    'comentario'?: string;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'comentario'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'nombreDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'urlDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'nombreDocumentoDos'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'urlDocumentoDos'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'nombreUsuario'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    'cvuUsuario'?: string;
}
/**
 * 
 * @export
 * @interface InstitucionSnp
 */
export interface InstitucionSnp {
    /**
     * Nombre de la institución
     * @type {string}
     * @memberof InstitucionSnp
     */
    'nombreSede'?: string;
    /**
     * rfc del usuario
     * @type {string}
     * @memberof InstitucionSnp
     */
    'rfc'?: string;
    /**
     * Número de registro
     * @type {string}
     * @memberof InstitucionSnp
     */
    'noDeRegistro'?: string;
    /**
     * Clave de la entidad federativa
     * @type {string}
     * @memberof InstitucionSnp
     */
    'claveEntidadFederativa'?: string;
    /**
     * Nombre de la entidad federativa
     * @type {string}
     * @memberof InstitucionSnp
     */
    'entidadFederativa'?: string;
    /**
     * Clave del municipio
     * @type {string}
     * @memberof InstitucionSnp
     */
    'claveMunicipio'?: string;
    /**
     * Nombre del municipio
     * @type {string}
     * @memberof InstitucionSnp
     */
    'municipio'?: string;
    /**
     * Nombre del sector
     * @type {string}
     * @memberof InstitucionSnp
     */
    'sector'?: string;
    /**
     * 
     * @type {Array<SubsedeSnp>}
     * @memberof InstitucionSnp
     */
    'subsdes'?: Array<SubsedeSnp>;
}
/**
 * 
 * @export
 * @interface ListaDocumentos
 */
export interface ListaDocumentos {
    /**
     * Lista de documentos generales asociados a un registro
     * @type {Array<Documento>}
     * @memberof ListaDocumentos
     */
    'documentos'?: Array<Documento>;
    /**
     * Lista de documentos de los represententes legales asociados a un registro
     * @type {Array<DocumentosRepresentante>}
     * @memberof ListaDocumentos
     */
    'representantesLegales'?: Array<DocumentosRepresentante>;
    /**
     * Lista de documentos de las subsedes asociadas a un registro
     * @type {Array<DocumentosSubsede>}
     * @memberof ListaDocumentos
     */
    'subsedes'?: Array<DocumentosSubsede>;
}
/**
 * 
 * @export
 * @interface MedioContacto
 */
export interface MedioContacto {
    /**
     * Identificador único del registro de contacto.
     * @type {number}
     * @memberof MedioContacto
     */
    'id'?: number;
    /**
     * ID del registro asociado.
     * @type {number}
     * @memberof MedioContacto
     */
    'registroId'?: number;
    /**
     * ID de la persona asociada.
     * @type {number}
     * @memberof MedioContacto
     */
    'personaId'?: number;
    /**
     * ID del tipo.
     * @type {string}
     * @memberof MedioContacto
     */
    'tipoId'?: string;
    /**
     * Nombre del tipo.
     * @type {string}
     * @memberof MedioContacto
     */
    'tipoNombre'?: string;
    /**
     * Indicador para saber si es contacto principal.
     * @type {boolean}
     * @memberof MedioContacto
     */
    'esPrincipal'?: boolean;
    /**
     * Indicador para saber si se migró de Rizoma.
     * @type {boolean}
     * @memberof MedioContacto
     */
    'esDeRizoma'?: boolean;
    /**
     * Valor del contacto; teléfono, email.
     * @type {string}
     * @memberof MedioContacto
     */
    'contacto'?: string;
}
/**
 * Clase que representa un nuevo registro con información de registro, persona y sector.
 * @export
 * @interface NuevoRegistro
 */
export interface NuevoRegistro {
    /**
     * 
     * @type {Registro}
     * @memberof NuevoRegistro
     */
    'registro'?: Registro;
    /**
     * 
     * @type {Persona}
     * @memberof NuevoRegistro
     */
    'persona'?: Persona;
    /**
     * 
     * @type {Sector}
     * @memberof NuevoRegistro
     */
    'sector'?: Sector;
}
/**
 * 
 * @export
 * @interface Persona
 */
export interface Persona {
    /**
     * Identificador único de la persona.
     * @type {number}
     * @memberof Persona
     */
    'id'?: number;
    /**
     * ID del registro asociado a la persona.
     * @type {number}
     * @memberof Persona
     */
    'registroId'?: number;
    /**
     * ID del tipo de identificación.
     * @type {string}
     * @memberof Persona
     */
    'tipoId'?: string;
    /**
     * Nombre del tipo de identificación.
     * @type {string}
     * @memberof Persona
     */
    'tipoNombre'?: string;
    /**
     * RFC (Registro Federal de Contribuyentes) de la persona.
     * @type {string}
     * @memberof Persona
     */
    'rfc'?: string;
    /**
     * CURP (Clave Única de Registro de Población) de la persona.
     * @type {string}
     * @memberof Persona
     */
    'curp'?: string;
    /**
     * CVU (Clave Única de Verificación) de la persona.
     * @type {string}
     * @memberof Persona
     */
    'cvu'?: string;
    /**
     * Nombre de la persona.
     * @type {string}
     * @memberof Persona
     */
    'nombre'?: string;
    /**
     * Primer apellido de la persona.
     * @type {string}
     * @memberof Persona
     */
    'primerApellido'?: string;
    /**
     * Segundo apellido de la persona.
     * @type {string}
     * @memberof Persona
     */
    'segundoApellido'?: string;
    /**
     * Fecha de registro de la persona.
     * @type {string}
     * @memberof Persona
     */
    'fechaRegistro'?: string;
    /**
     * ID del género de la persona.
     * @type {string}
     * @memberof Persona
     */
    'generoId'?: string;
    /**
     * Nombre del género de la persona.
     * @type {string}
     * @memberof Persona
     */
    'generoNombre'?: string;
    /**
     * ID del estado conyugal de la persona.
     * @type {string}
     * @memberof Persona
     */
    'estadoConyugalId'?: string;
    /**
     * Nombre del estado conyugal de la persona.
     * @type {string}
     * @memberof Persona
     */
    'estadoConyugalNombre'?: string;
    /**
     * ID de la nacionalidad de la persona.
     * @type {string}
     * @memberof Persona
     */
    'nacionalidadId'?: string;
    /**
     * Nombre de la nacionalidad de la persona.
     * @type {string}
     * @memberof Persona
     */
    'nacionalidadNombre'?: string;
    /**
     * ID del país de nacimiento de la persona.
     * @type {string}
     * @memberof Persona
     */
    'paisNacimientoId'?: string;
    /**
     * Nombre del país de nacimiento de la persona.
     * @type {string}
     * @memberof Persona
     */
    'paisNacimientoNombre'?: string;
    /**
     * ID de la entidad federativa de nacimiento de la persona.
     * @type {string}
     * @memberof Persona
     */
    'entidadFederativaId'?: string;
    /**
     * Nombre de la entidad federativa de nacimiento de la persona.
     * @type {string}
     * @memberof Persona
     */
    'entidadFederativaNombre'?: string;
    /**
     * Indica si la persona está activa o no.
     * @type {boolean}
     * @memberof Persona
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface PersonaFisica
 */
export interface PersonaFisica {
    /**
     * 
     * @type {TipoPersona}
     * @memberof PersonaFisica
     */
    'tipoPersona'?: TipoPersona;
    /**
     * 
     * @type {string}
     * @memberof PersonaFisica
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaFisica
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaFisica
     */
    'apellidoPaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaFisica
     */
    'apellidoMaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaFisica
     */
    'curp'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonaFisica
     */
    'rfc'?: string;
    /**
     * 
     * @type {Array<PoderOtorgadoReniecyt>}
     * @memberof PersonaFisica
     */
    'poderOtorgado'?: Array<PoderOtorgadoReniecyt>;
}
/**
 * 
 * @export
 * @interface Plataforma
 */
export interface Plataforma {
    /**
     * Identificador único de la Plataforma.
     * @type {number}
     * @memberof Plataforma
     */
    'id'?: number;
    /**
     * Descripción de la plataforma.
     * @type {string}
     * @memberof Plataforma
     */
    'nombre'?: string;
    /**
     * Descripción de la plataforma.
     * @type {string}
     * @memberof Plataforma
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface PoderOtorgado
 */
export interface PoderOtorgado {
    /**
     * Identificador único del poder otorgado
     * @type {number}
     * @memberof PoderOtorgado
     */
    'id'?: number;
    /**
     * Identificador de la persona que recibe el poder
     * @type {number}
     * @memberof PoderOtorgado
     */
    'persona_id'?: number;
    /**
     * Nombre del poder otorgado
     * @type {string}
     * @memberof PoderOtorgado
     */
    'poderOtorgadoNombre'?: string;
    /**
     * URL del poder otorgado
     * @type {string}
     * @memberof PoderOtorgado
     */
    'poderOtorgadoUrl'?: string;
    /**
     * ID del poder otorgado
     * @type {string}
     * @memberof PoderOtorgado
     */
    'poderOtorgadoId'?: string;
    /**
     * ID de la entidad
     * @type {string}
     * @memberof PoderOtorgado
     */
    'entidadId'?: string;
    /**
     * Nombre de la entidad
     * @type {string}
     * @memberof PoderOtorgado
     */
    'entidadNombre'?: string;
    /**
     * ID del municipio
     * @type {string}
     * @memberof PoderOtorgado
     */
    'municipioId'?: string;
    /**
     * Nombre del municipio
     * @type {string}
     * @memberof PoderOtorgado
     */
    'municipioNombre'?: string;
    /**
     * ID de la localidad
     * @type {string}
     * @memberof PoderOtorgado
     */
    'localidadId'?: string;
    /**
     * Nombre de la localidad
     * @type {string}
     * @memberof PoderOtorgado
     */
    'localidadNombre'?: string;
    /**
     * ID del tipo de poder
     * @type {string}
     * @memberof PoderOtorgado
     */
    'tipoPoderId'?: string;
    /**
     * Nombre del tipoPoder
     * @type {string}
     * @memberof PoderOtorgado
     */
    'tipoPoderNombre'?: string;
    /**
     * Número documento
     * @type {string}
     * @memberof PoderOtorgado
     */
    'numeroDocumento'?: string;
    /**
     * Nombre del notario
     * @type {string}
     * @memberof PoderOtorgado
     */
    'nombreNotario'?: string;
    /**
     * Número notario
     * @type {string}
     * @memberof PoderOtorgado
     */
    'numeroNotario'?: string;
    /**
     * Fecha documento
     * @type {string}
     * @memberof PoderOtorgado
     */
    'fechaDocumento'?: string;
    /**
     * Nombre de documento
     * @type {string}
     * @memberof PoderOtorgado
     */
    'nombreDocumento'?: string;
    /**
     * Puesto del funcionario
     * @type {string}
     * @memberof PoderOtorgado
     */
    'puestoFuncionario'?: string;
    /**
     * Facultad del representante
     * @type {string}
     * @memberof PoderOtorgado
     */
    'facultadRepresentante'?: string;
}
/**
 * 
 * @export
 * @interface PoderOtorgadoReniecyt
 */
export interface PoderOtorgadoReniecyt {
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'numeroDocumento'?: string;
    /**
     * 
     * @type {number}
     * @memberof PoderOtorgadoReniecyt
     */
    'numeroNotario'?: number;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'nombreNotario'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'estado'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'municipio'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'tipoPoder'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'ciudad'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'poderOtorgado'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'fechaExpedicion'?: string;
    /**
     * 
     * @type {string}
     * @memberof PoderOtorgadoReniecyt
     */
    'lugarExpedicion'?: string;
}
/**
 * 
 * @export
 * @interface Problem
 */
export interface Problem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced, it SHOULD provide human-readable documentation for the problem type (e.g., using HTML). 
     * @type {string}
     * @memberof Problem
     */
    'type'?: string;
    /**
     * A short, summary of the problem type. Written in english and readable for engineers (usually not suited for non technical stakeholders and not localized); example: Service Unavailable 
     * @type {string}
     * @memberof Problem
     */
    'title'?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem. 
     * @type {number}
     * @memberof Problem
     */
    'status'?: number;
    /**
     * A human readable explanation specific to this occurrence of the problem. 
     * @type {string}
     * @memberof Problem
     */
    'detail'?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced. 
     * @type {string}
     * @memberof Problem
     */
    'instance'?: string;
}
/**
 * 
 * @export
 * @interface Registro
 */
export interface Registro {
    /**
     * Identificador único del registro.
     * @type {number}
     * @memberof Registro
     */
    'id'?: number;
    /**
     * ID de la sede.
     * @type {number}
     * @memberof Registro
     */
    'sedeId'?: number;
    /**
     * ID del tipo de solicitud.
     * @type {string}
     * @memberof Registro
     */
    'tipoSolicitudId'?: string;
    /**
     * Nombre del tipo de solicitud.
     * @type {string}
     * @memberof Registro
     */
    'tipoSolicitudNombre'?: string;
    /**
     * RFC.
     * @type {string}
     * @memberof Registro
     */
    'rfc'?: string;
    /**
     * Nombre.
     * @type {string}
     * @memberof Registro
     */
    'nombre'?: string;
    /**
     * Primer apellido.
     * @type {string}
     * @memberof Registro
     */
    'primerApellido'?: string;
    /**
     * Segundo apellido.
     * @type {string}
     * @memberof Registro
     */
    'segundoApellido'?: string;
    /**
     * ID de la actividad.
     * @type {string}
     * @memberof Registro
     */
    'actividadId'?: string;
    /**
     * Nombre de la actividad.
     * @type {string}
     * @memberof Registro
     */
    'actividadNombre'?: string;
    /**
     * ID del sector.
     * @type {string}
     * @memberof Registro
     */
    'sectorId'?: string;
    /**
     * Nombre del sector.
     * @type {string}
     * @memberof Registro
     */
    'sectorNombre'?: string;
    /**
     * Razón social.
     * @type {string}
     * @memberof Registro
     */
    'razonSocial'?: string;
    /**
     * ID del tipo de institución.
     * @type {string}
     * @memberof Registro
     */
    'tipoInstitucionId'?: string;
    /**
     * Nombre del tipo de institución.
     * @type {string}
     * @memberof Registro
     */
    'tipoInstitucionNombre'?: string;
    /**
     * ID del nivel.
     * @type {string}
     * @memberof Registro
     */
    'nivelId'?: string;
    /**
     * Nombre del nivel.
     * @type {string}
     * @memberof Registro
     */
    'nivelNombre'?: string;
    /**
     * ID de la figura jurídica.
     * @type {string}
     * @memberof Registro
     */
    'figuraJuridicaId'?: string;
    /**
     * Nombre de la figura jurídica.
     * @type {string}
     * @memberof Registro
     */
    'figuraJuridicaNombre'?: string;
    /**
     * ID del grupo social.
     * @type {string}
     * @memberof Registro
     */
    'grupoSocialId'?: string;
    /**
     * Nombre del grupo social.
     * @type {string}
     * @memberof Registro
     */
    'grupoSocialNombre'?: string;
    /**
     * Especificación del grupo social.
     * @type {string}
     * @memberof Registro
     */
    'grupoSocialEspecificar'?: string;
    /**
     * ID de la clasificación.
     * @type {string}
     * @memberof Registro
     */
    'clasificacionId'?: string;
    /**
     * Nombre de la clasificación.
     * @type {string}
     * @memberof Registro
     */
    'clasificacionNombre'?: string;
    /**
     * ID del tamaño.
     * @type {string}
     * @memberof Registro
     */
    'tamanioId'?: string;
    /**
     * Nombre del tamaño.
     * @type {string}
     * @memberof Registro
     */
    'tamanioNombre'?: string;
    /**
     * Número de registro.
     * @type {string}
     * @memberof Registro
     */
    'noDeRegistro'?: string;
    /**
     * Número de registro anterior.
     * @type {string}
     * @memberof Registro
     */
    'noDeRegistroAnterior'?: string;
    /**
     * Número de proyecto de registro permanente.
     * @type {string}
     * @memberof Registro
     */
    'numProyectoRegistroPermanente'?: string;
    /**
     * Programa Reniecyt permanente.
     * @type {string}
     * @memberof Registro
     */
    'programaReniecytPermanente'?: string;
    /**
     * Convocatoria Reniecyt permanente.
     * @type {string}
     * @memberof Registro
     */
    'convReniecytPermanente'?: string;
    /**
     * Fecha de alta del número de registro.
     * @type {string}
     * @memberof Registro
     */
    'vigenicaAltaNoRegistro'?: string;
    /**
     * Fecha de fin de vigencia del número de registro.
     * @type {string}
     * @memberof Registro
     */
    'vigenciaFinNoRegistro'?: string;
    /**
     * Consecutivo de la subsede.
     * @type {string}
     * @memberof Registro
     */
    'consecutivoSubsede'?: string;
    /**
     * Indica si el registro está activo o no.
     * @type {boolean}
     * @memberof Registro
     */
    'activated'?: boolean;
    /**
     * Indica si el registro está migrado o no.
     * @type {boolean}
     * @memberof Registro
     */
    'esMigrado'?: boolean;
    /**
     * Indica si el registro tiene subsede.
     * @type {boolean}
     * @memberof Registro
     */
    'tieneSubsede'?: boolean;
    /**
     * Indica si el registro esta asignado.
     * @type {boolean}
     * @memberof Registro
     */
    'asignado'?: boolean;
    /**
     * Indica si el registro esta reseteado.
     * @type {boolean}
     * @memberof Registro
     */
    'reseteado'?: boolean;
}
/**
 * 
 * @export
 * @interface RegistroCancelacionIncumplimiento
 */
export interface RegistroCancelacionIncumplimiento {
    /**
     * Unidad administrativa que solicitó la cancelación.
     * @type {string}
     * @memberof RegistroCancelacionIncumplimiento
     */
    'unidadAdministrativa'?: string;
    /**
     * Funcionario solicitante de la cancelación.
     * @type {string}
     * @memberof RegistroCancelacionIncumplimiento
     */
    'funcionarioSolicitante'?: string;
    /**
     * Fecha de solicitud de cancelación.
     * @type {string}
     * @memberof RegistroCancelacionIncumplimiento
     */
    'fechaSolicitud'?: string;
    /**
     * Número de oficio asociado a la cancelación.
     * @type {string}
     * @memberof RegistroCancelacionIncumplimiento
     */
    'numeroOficio'?: string;
    /**
     * Justificación del incumplimiento.
     * @type {string}
     * @memberof RegistroCancelacionIncumplimiento
     */
    'justificacionCumplimiento'?: string;
    /**
     * Lista de documentos relacionados con el registro de cancelación.
     * @type {Array<DocumentoCancelacionIncumplimiento>}
     * @memberof RegistroCancelacionIncumplimiento
     */
    'documentos'?: Array<DocumentoCancelacionIncumplimiento>;
}
/**
 * 
 * @export
 * @interface RegistroDomicilio
 */
export interface RegistroDomicilio {
    /**
     * Identificador único del registro de domicilio.
     * @type {number}
     * @memberof RegistroDomicilio
     */
    'id'?: number;
    /**
     * ID del registro asociado.
     * @type {number}
     * @memberof RegistroDomicilio
     */
    'registroId'?: number;
    /**
     * ID de la persona asociada.
     * @type {number}
     * @memberof RegistroDomicilio
     */
    'personaId'?: number;
    /**
     * ID del tipo.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoId'?: string;
    /**
     * Nombre del tipo.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoNombre'?: string;
    /**
     * Código postal.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'codigoPostal'?: string;
    /**
     * ID del estado.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'estadoId'?: string;
    /**
     * Nombre del estado.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'estadoNombre'?: string;
    /**
     * ID del municipio.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'municipioId'?: string;
    /**
     * Nombre del municipio.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'municipioNombre'?: string;
    /**
     * ID de la localidad.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'localidadId'?: string;
    /**
     * Nombre de la localidad.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'localidadNombre'?: string;
    /**
     * ID del asentamiento.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'asentamientoId'?: string;
    /**
     * Nombre del asentamiento.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'asentamientoNombre'?: string;
    /**
     * Indicador de si es una carretera.
     * @type {boolean}
     * @memberof RegistroDomicilio
     */
    'esCarretera'?: boolean;
    /**
     * Indicador de si es un camino.
     * @type {boolean}
     * @memberof RegistroDomicilio
     */
    'esCamino'?: boolean;
    /**
     * ID del tipo de calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoCalleId'?: string;
    /**
     * Nombre del tipo de calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoCalleNombre'?: string;
    /**
     * Nombre de la calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'nombreCalle'?: string;
    /**
     * Origen del tramo.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'origenTramo'?: string;
    /**
     * Destino del tramo.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'destinoTramo'?: string;
    /**
     * ID del margen.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'margenId'?: string;
    /**
     * Nombre del margen.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'margenNombre'?: string;
    /**
     * Cadenamiento.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'cadenamiento'?: string;
    /**
     * Número exterior.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'numeroExterior'?: string;
    /**
     * Número exterior alfanumerico.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'numeroExteriorAlfanumerico'?: string;
    /**
     * Número exterior anterior.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'numeroExteriorAnterior'?: string;
    /**
     * Número interior.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'numeroInterior'?: string;
    /**
     * Número interior alfanumerico.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'numeroInteriorAlfanumerico'?: string;
    /**
     * ID del tipo de la primera entre calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'entreCalle1TipoId'?: string;
    /**
     * Nombre del tipo de la primera entre calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'entreCalle1TipoNombre'?: string;
    /**
     * ID del tipo de la segunda entre calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'entreCalle2TipoId'?: string;
    /**
     * Nombre del tipo de la segunda entre calle.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'entreCalle2TipoNombre'?: string;
    /**
     * ID del tipo posterior.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'posteriorTipoId'?: string;
    /**
     * Nombre del tipo posterior.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'posteriorTipoNombre'?: string;
    /**
     * Nombre posterior.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'posteriorNombre'?: string;
    /**
     * Descripción de la ubicación.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'descripcionUbicacion'?: string;
    /**
     * Indicador de si es extranjero.
     * @type {boolean}
     * @memberof RegistroDomicilio
     */
    'esExtranjero'?: boolean;
    /**
     * ID del tipo de vialidad.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoVialidadId'?: string;
    /**
     * Nombre del tipo de vialidad.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoVialidadNombre'?: string;
    /**
     * Indicador de activación.
     * @type {boolean}
     * @memberof RegistroDomicilio
     */
    'activated'?: boolean;
    /**
     * ID del tipo de asentamiento.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoAsentamientoId'?: string;
    /**
     * Nombre del tipo de asentamiento.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'tipoAsentamientoNombre'?: string;
    /**
     * Nombre de la vialidad 1 de entre calles.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'entreC1Nombre'?: string;
    /**
     * Nombre de la vialidad 2 de entre calles.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'entreC2Nombre'?: string;
    /**
     * Id de la administración.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'administracionId'?: string;
    /**
     * Nombre de la administración.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'administracionNombre'?: string;
    /**
     * Id del derecho de transito.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'derechoTransitoId'?: string;
    /**
     * Nombre del derecho de transito.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'derechoTransitoNombre'?: string;
    /**
     * Código del registro de domicilio.
     * @type {string}
     * @memberof RegistroDomicilio
     */
    'codigo'?: string;
}
/**
 * 
 * @export
 * @interface RegistroEstatus
 */
export interface RegistroEstatus {
    /**
     * Identificador único del registro estatus.
     * @type {string}
     * @memberof RegistroEstatus
     */
    'id'?: string;
    /**
     * El ID del registro estatus asociado al registro.
     * @type {string}
     * @memberof RegistroEstatus
     */
    'idRegistroEstatus'?: string;
    /**
     * Clave del estado del registro.
     * @type {string}
     * @memberof RegistroEstatus
     */
    'claveEstatus'?: string;
    /**
     * El estatus de la solicitud.
     * @type {string}
     * @memberof RegistroEstatus
     */
    'nombreEstatus'?: string;
    /**
     * Indica si el registro esta asignado.
     * @type {boolean}
     * @memberof RegistroEstatus
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface RegistroReniecyt
 */
export interface RegistroReniecyt {
    /**
     * 
     * @type {number}
     * @memberof RegistroReniecyt
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'origen'?: string;
    /**
     * 
     * @type {TipoPersona}
     * @memberof RegistroReniecyt
     */
    'tipoPersona'?: TipoPersona;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'reniecyt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'razonSocial'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'apellidoPaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'apellidoMaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'rfc'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'sector'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'tipo'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'tipoInstitucionNombre'?: string;
    /**
     * 
     * @type {EntidadFederativa}
     * @memberof RegistroReniecyt
     */
    'entidad'?: EntidadFederativa;
    /**
     * 
     * @type {DomicilioReniecyt}
     * @memberof RegistroReniecyt
     */
    'domicilio'?: DomicilioReniecyt;
    /**
     * 
     * @type {Array<PersonaFisica>}
     * @memberof RegistroReniecyt
     */
    'representantesLegales'?: Array<PersonaFisica>;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'reniecytAnterior'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'fechaAlta'?: string;
    /**
     * 
     * @type {object}
     * @memberof RegistroReniecyt
     */
    'documentoCreacion'?: object;
    /**
     * 
     * @type {object}
     * @memberof RegistroReniecyt
     */
    'estatus'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof RegistroReniecyt
     */
    'documentos'?: Array<object>;
    /**
     * Indica si el registro es subsede (Sí/No)
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'subsede'?: string;
    /**
     * Tamaño de la empresa
     * @type {string}
     * @memberof RegistroReniecyt
     */
    'tamanioEmpresa'?: string;
    /**
     * 
     * @type {SectorIndustrialScianReniecyt}
     * @memberof RegistroReniecyt
     */
    'sectorIndustrialScian'?: SectorIndustrialScianReniecyt;
    /**
     * 
     * @type {SectorIndustrialOcdeReniecyt}
     * @memberof RegistroReniecyt
     */
    'sectorIndustrialOcde'?: SectorIndustrialOcdeReniecyt;
    /**
     * 
     * @type {AreaConocimientoReniecyt}
     * @memberof RegistroReniecyt
     */
    'areaConocimiento'?: AreaConocimientoReniecyt;
}
/**
 * 
 * @export
 * @interface Sector
 */
export interface Sector {
    /**
     * Identificador único del sector.
     * @type {number}
     * @memberof Sector
     */
    'id'?: number;
    /**
     * ID del registro asociado al sector.
     * @type {number}
     * @memberof Sector
     */
    'registroId'?: number;
    /**
     * ID del sector SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianSectorId'?: string;
    /**
     * Nombre del sector SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianSectorNombre'?: string;
    /**
     * ID del subsector SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianSubsectorId'?: string;
    /**
     * Nombre del subsector SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianSubsectorNombre'?: string;
    /**
     * ID de la rama SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianRamaId'?: string;
    /**
     * Nombre de la rama SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianRamaNombre'?: string;
    /**
     * ID de la subrama SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianSubramaId'?: string;
    /**
     * Nombre de la subrama SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianSubramaNombre'?: string;
    /**
     * ID de la clase SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianClaseId'?: string;
    /**
     * Nombre de la clase SCIAN.
     * @type {string}
     * @memberof Sector
     */
    'scianClaseNombre'?: string;
    /**
     * ID del sector OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeSectorId'?: string;
    /**
     * Nombre del sector OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeSectorNombre'?: string;
    /**
     * ID de la división OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeDivisionId'?: string;
    /**
     * Nombre de la división OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeDivisionNombre'?: string;
    /**
     * ID del grupo OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeGrupoId'?: string;
    /**
     * Nombre del grupo OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeGrupoNombre'?: string;
    /**
     * ID de la clase OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeClaseId'?: string;
    /**
     * Nombre de la clase OCDE.
     * @type {string}
     * @memberof Sector
     */
    'ocdeClaseNombre'?: string;
    /**
     * ID del área.
     * @type {string}
     * @memberof Sector
     */
    'areaAreaId'?: string;
    /**
     * Nombre del área.
     * @type {string}
     * @memberof Sector
     */
    'areaAreaNombre'?: string;
    /**
     * ID del campo.
     * @type {string}
     * @memberof Sector
     */
    'areaCampoId'?: string;
    /**
     * Nombre del campo.
     * @type {string}
     * @memberof Sector
     */
    'areaCampoNombre'?: string;
    /**
     * ID de la disciplina.
     * @type {string}
     * @memberof Sector
     */
    'areaDisciplinaId'?: string;
    /**
     * Nombre de la disciplina.
     * @type {string}
     * @memberof Sector
     */
    'areaDisciplinaNombre'?: string;
    /**
     * ID de la subdisciplina.
     * @type {string}
     * @memberof Sector
     */
    'areaSubdisciplinaId'?: string;
    /**
     * Nombre de la subdisciplina.
     * @type {string}
     * @memberof Sector
     */
    'areaSubdisciplinaNombre'?: string;
    /**
     * Indica si el sector está activo o no.
     * @type {boolean}
     * @memberof Sector
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface SectorIndustrialOcdeReniecyt
 */
export interface SectorIndustrialOcdeReniecyt {
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialOcdeReniecyt
     */
    'sector'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialOcdeReniecyt
     */
    'division'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialOcdeReniecyt
     */
    'grupo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialOcdeReniecyt
     */
    'clase'?: string;
}
/**
 * 
 * @export
 * @interface SectorIndustrialScianReniecyt
 */
export interface SectorIndustrialScianReniecyt {
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialScianReniecyt
     */
    'sector'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialScianReniecyt
     */
    'subsector'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialScianReniecyt
     */
    'rama'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialScianReniecyt
     */
    'subrama'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorIndustrialScianReniecyt
     */
    'clase'?: string;
}
/**
 * 
 * @export
 * @interface Socio
 */
export interface Socio {
    /**
     * Identificador único del socio
     * @type {number}
     * @memberof Socio
     */
    'id'?: number;
    /**
     * Identificador del registro asociado al socio
     * @type {number}
     * @memberof Socio
     */
    'registroId'?: number;
    /**
     * Nombre del socio
     * @type {string}
     * @memberof Socio
     */
    'nombre'?: string;
    /**
     * Primer apellido del socio
     * @type {string}
     * @memberof Socio
     */
    'primerApellido'?: string;
    /**
     * Segundo apellido del socio
     * @type {string}
     * @memberof Socio
     */
    'segundoApellido'?: string;
    /**
     * Indicador de activación del socio
     * @type {boolean}
     * @memberof Socio
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface Solicitud
 */
export interface Solicitud {
    /**
     * El ID del registro asociado a la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'idRegistro'?: string;
    /**
     * El ID de la sede padre
     * @type {string}
     * @memberof Solicitud
     */
    'idSede'?: string;
    /**
     * El ID del registro del Representante Legal asociado a la solicitud para Personas Físicas.
     * @type {string}
     * @memberof Solicitud
     */
    'idPersona'?: string;
    /**
     * RFC (Registro Federal de Contribuyentes) de la persona.
     * @type {string}
     * @memberof Solicitud
     */
    'rfc'?: string;
    /**
     * El número Reniecyt asociado a la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'numeroReniecyt'?: string;
    /**
     * El nombre de la empresa o institución asociada a la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'empresaInstitucion'?: string;
    /**
     * La fecha de creación de la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'fechaCreacion'?: string;
    /**
     * El ID del estatus asociado a la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'idEstatus'?: string;
    /**
     * Clave del estado del registro.
     * @type {string}
     * @memberof Solicitud
     */
    'clave'?: string;
    /**
     * El estatus actual de la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'estatus'?: string;
    /**
     * Información sobre algún incumplimiento asociado a la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'incumplimiento'?: string;
    /**
     * Información sobre si la solicitud es tipo de persona Moral o Física.
     * @type {string}
     * @memberof Solicitud
     */
    'tipoPersona'?: string;
    /**
     * Información sobre el tipo de sector de una solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'tipoSector'?: string;
    /**
     * Información sobre el comentario del estatus de una solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'comentarioEstatus'?: string;
    /**
     * El ID del registro estatus asociado a la solicitud.
     * @type {string}
     * @memberof Solicitud
     */
    'idRegistroEstatus'?: string;
    /**
     * Indica si el registro esta asignado.
     * @type {boolean}
     * @memberof Solicitud
     */
    'asignado'?: boolean;
    /**
     * Indica si el registro esta reseteado.
     * @type {boolean}
     * @memberof Solicitud
     */
    'reseteado'?: boolean;
}
/**
 * Información de subsedes
 * @export
 * @interface Subsede
 */
export interface Subsede {
    /**
     * Nombre de la institución
     * @type {string}
     * @memberof Subsede
     */
    'nombreSede'?: string;
    /**
     * Clave de la entidad federativa
     * @type {string}
     * @memberof Subsede
     */
    'claveEntidadFederativa'?: string;
    /**
     * Nombre de la entidad federativa
     * @type {string}
     * @memberof Subsede
     */
    'entidadFederativa'?: string;
    /**
     * Clave del municipio
     * @type {string}
     * @memberof Subsede
     */
    'claveMunicipio'?: string;
    /**
     * Nombre del municipio
     * @type {string}
     * @memberof Subsede
     */
    'municipio'?: string;
    /**
     * Número de registro
     * @type {string}
     * @memberof Subsede
     */
    'reniecyt'?: string;
}
/**
 * 
 * @export
 * @interface SubsedeEstatus
 */
export interface SubsedeEstatus {
    /**
     * El ID del registro asociado a la solicitud.
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'idRegistro'?: string;
    /**
     * El número Reniecyt asociado a la solicitud.
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'numeroReniecyt'?: string;
    /**
     * El nombre de la empresa o institución asociada a la solicitud.
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'empresaInstitucion'?: string;
    /**
     * Clave del estado del registro.
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'clave'?: string;
    /**
     * El estatus actual de la solicitud.
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'estatusSolicitud'?: string;
    /**
     * Información sobre si la solicitud es tipo de persona Moral o Física.
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'tipoPersona'?: string;
    /**
     * Indica si la subsede esta completa o no
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'estatus'?: string;
    /**
     * Muestra un mensaje indicando que le falta a la subsede
     * @type {string}
     * @memberof SubsedeEstatus
     */
    'incompletaMensaje'?: string;
}
/**
 * 
 * @export
 * @interface SubsedeSnp
 */
export interface SubsedeSnp {
    /**
     * Nombre de la institución
     * @type {string}
     * @memberof SubsedeSnp
     */
    'nombreSede'?: string;
    /**
     * Número de registro
     * @type {string}
     * @memberof SubsedeSnp
     */
    'noDeRegistro'?: string;
    /**
     * Clave de la entidad federativa
     * @type {string}
     * @memberof SubsedeSnp
     */
    'claveEntidadFederativa'?: string;
    /**
     * Nombre de la entidad federativa
     * @type {string}
     * @memberof SubsedeSnp
     */
    'entidadFederativa'?: string;
    /**
     * Clave del municipio
     * @type {string}
     * @memberof SubsedeSnp
     */
    'claveMunicipio'?: string;
    /**
     * Nombre del municipio
     * @type {string}
     * @memberof SubsedeSnp
     */
    'municipio'?: string;
}
/**
 * 
 * @export
 * @interface Subsistema
 */
export interface Subsistema {
    /**
     * Identificador único del Subsistema.
     * @type {number}
     * @memberof Subsistema
     */
    'id'?: number;
    /**
     * Descripción del subsistema.
     * @type {string}
     * @memberof Subsistema
     */
    'nombre'?: string;
    /**
     * Descripción del subsistema.
     * @type {string}
     * @memberof Subsistema
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface TipoPersona
 */
export interface TipoPersona {
    /**
     * 
     * @type {string}
     * @memberof TipoPersona
     */
    'nombre'?: string;
}
/**
 * 
 * @export
 * @interface TipoUsuario
 */
export interface TipoUsuario {
    /**
     * Identificador único del tipo de usuario.
     * @type {string}
     * @memberof TipoUsuario
     */
    'id'?: string;
    /**
     * Descripción del tipo de usuario.
     * @type {string}
     * @memberof TipoUsuario
     */
    'nombre'?: string;
}
/**
 * 
 * @export
 * @interface ValidateSubsede
 */
export interface ValidateSubsede {
    /**
     * Identificador de la sub-sede.
     * @type {number}
     * @memberof ValidateSubsede
     */
    'idSubsede'?: number;
    /**
     * Estado de la validación de la sub-sede, si una subsede no tiene domicilio o una url en el poder otorgado devuelve un false.
     * @type {boolean}
     * @memberof ValidateSubsede
     */
    'status'?: boolean;
    /**
     * Descripción del error en caso de no cumplir con alguna validación
     * @type {string}
     * @memberof ValidateSubsede
     */
    'descripcion'?: string;
}

/**
 * ComentariosApi - axios parameter creator
 * @export
 */
export const ComentariosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioPersonaRegistro: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getComentarioPersonaRegistro', 'idPersona', idPersona)
            const localVarPath = `/persona-registro/comentario/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComentariosApi - functional programming interface
 * @export
 */
export const ComentariosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComentariosApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentarioPersonaRegistro(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComentarioPersonaRegistro>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentarioPersonaRegistro(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComentariosApi - factory interface
 * @export
 */
export const ComentariosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComentariosApiFp(configuration)
    return {
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioPersonaRegistro(idPersona: number, options?: any): AxiosPromise<ComentarioPersonaRegistro> {
            return localVarFp.getComentarioPersonaRegistro(idPersona, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComentariosApi - object-oriented interface
 * @export
 * @class ComentariosApi
 * @extends {BaseAPI}
 */
export class ComentariosApi extends BaseAPI {
    /**
     * Obtiene el comentario de una persona eliminada
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComentariosApi
     */
    public getComentarioPersonaRegistro(idPersona: number, options?: AxiosRequestConfig) {
        return ComentariosApiFp(this.configuration).getComentarioPersonaRegistro(idPersona, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComentariosTemporalesApi - axios parameter creator
 * @export
 */
export const ComentariosTemporalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioTemporalRegistro: async (idRegistroEstatus: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistroEstatus' is not null or undefined
            assertParamExists('getComentarioTemporalRegistro', 'idRegistroEstatus', idRegistroEstatus)
            const localVarPath = `/registro/comentarioTemporales/{idRegistroEstatus}`
                .replace(`{${"idRegistroEstatus"}}`, encodeURIComponent(String(idRegistroEstatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarComentarioTemporal: async (comentarioRegistroEstatus: ComentarioRegistroEstatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comentarioRegistroEstatus' is not null or undefined
            assertParamExists('guardarComentarioTemporal', 'comentarioRegistroEstatus', comentarioRegistroEstatus)
            const localVarPath = `/registro/comentarioTemporales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comentarioRegistroEstatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComentariosTemporalesApi - functional programming interface
 * @export
 */
export const ComentariosTemporalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComentariosTemporalesApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentarioTemporalRegistro(idRegistroEstatus: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComentarioRegistroEstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentarioTemporalRegistro(idRegistroEstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarComentarioTemporal(comentarioRegistroEstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComentariosTemporalesApi - factory interface
 * @export
 */
export const ComentariosTemporalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComentariosTemporalesApiFp(configuration)
    return {
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioTemporalRegistro(idRegistroEstatus: number, options?: any): AxiosPromise<ComentarioRegistroEstatus> {
            return localVarFp.getComentarioTemporalRegistro(idRegistroEstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: any): AxiosPromise<void> {
            return localVarFp.guardarComentarioTemporal(comentarioRegistroEstatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComentariosTemporalesApi - object-oriented interface
 * @export
 * @class ComentariosTemporalesApi
 * @extends {BaseAPI}
 */
export class ComentariosTemporalesApi extends BaseAPI {
    /**
     * Obtiene los comentarios asociados a un registro
     * @param {number} idRegistroEstatus Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComentariosTemporalesApi
     */
    public getComentarioTemporalRegistro(idRegistroEstatus: number, options?: AxiosRequestConfig) {
        return ComentariosTemporalesApiFp(this.configuration).getComentarioTemporalRegistro(idRegistroEstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Guarda el comentario temporal
     * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComentariosTemporalesApi
     */
    public guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: AxiosRequestConfig) {
        return ComentariosTemporalesApiFp(this.configuration).guardarComentarioTemporal(comentarioRegistroEstatus, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContactoApi - axios parameter creator
 * @export
 */
export const ContactoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedioContacto: async (idPersona: number, idRegistro: number, medioContacto: MedioContacto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createMedioContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createMedioContacto', 'idRegistro', idRegistro)
            // verify required parameter 'medioContacto' is not null or undefined
            assertParamExists('createMedioContacto', 'medioContacto', medioContacto)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medioContacto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediosContacto: async (idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createMediosContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createMediosContacto', 'idRegistro', idRegistro)
            // verify required parameter 'medioContacto' is not null or undefined
            assertParamExists('createMediosContacto', 'medioContacto', medioContacto)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}/bulk`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medioContacto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediosContacto: async (idPersona: number, idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getMediosContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getMediosContacto', 'idRegistro', idRegistro)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactoApi - functional programming interface
 * @export
 */
export const ContactoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactoApiAxiosParamCreator(configuration)
    return {
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedioContacto(idPersona, idRegistro, medioContacto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMediosContacto(idPersona, idRegistro, medioContacto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediosContacto(idPersona: number, idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MedioContacto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediosContacto(idPersona, idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactoApi - factory interface
 * @export
 */
export const ContactoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactoApiFp(configuration)
    return {
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: any): AxiosPromise<void> {
            return localVarFp.createMedioContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: any): AxiosPromise<void> {
            return localVarFp.createMediosContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediosContacto(idPersona: number, idRegistro: number, options?: any): AxiosPromise<Array<MedioContacto>> {
            return localVarFp.getMediosContacto(idPersona, idRegistro, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactoApi - object-oriented interface
 * @export
 * @class ContactoApi
 * @extends {BaseAPI}
 */
export class ContactoApi extends BaseAPI {
    /**
     * Crear un nuevo medio de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {MedioContacto} medioContacto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactoApi
     */
    public createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: AxiosRequestConfig) {
        return ContactoApiFp(this.configuration).createMedioContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {Array<MedioContacto>} medioContacto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactoApi
     */
    public createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: AxiosRequestConfig) {
        return ContactoApiFp(this.configuration).createMediosContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los medios de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactoApi
     */
    public getMediosContacto(idPersona: number, idRegistro: number, options?: AxiosRequestConfig) {
        return ContactoApiFp(this.configuration).getMediosContacto(idPersona, idRegistro, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentosApi - axios parameter creator
 * @export
 */
export const DocumentosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Crear un nuevo documento para el registro del representante
         * @param {number} id Identificador único
         * @param {DocumentoRepresentante} documentoRepresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoRepresentante: async (id: number, documentoRepresentante: DocumentoRepresentante, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocumentoRepresentante', 'id', id)
            // verify required parameter 'documentoRepresentante' is not null or undefined
            assertParamExists('createDocumentoRepresentante', 'documentoRepresentante', documentoRepresentante)
            const localVarPath = `/documento-representante/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoRepresentante, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo documento para el registro de sede
         * @param {number} id Identificador único
         * @param {DocumentoSede} documentoSede 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoSede: async (id: number, documentoSede: DocumentoSede, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocumentoSede', 'id', id)
            // verify required parameter 'documentoSede' is not null or undefined
            assertParamExists('createDocumentoSede', 'documentoSede', documentoSede)
            const localVarPath = `/documento-sede/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoSede, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo socio de un documento creación
         * @param {number} id Identificador único
         * @param {Socio} socio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSocio: async (id: number, socio: Socio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSocio', 'id', id)
            // verify required parameter 'socio' is not null or undefined
            assertParamExists('createSocio', 'socio', socio)
            const localVarPath = `/socio/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un socio de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSocio: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSocio', 'id', id)
            const localVarPath = `/socio/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el documento del representante
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoRepresentante: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentoRepresentante', 'id', id)
            const localVarPath = `/documento-representante/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el documento de un registro de sede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoSede: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentoSede', 'id', id)
            const localVarPath = `/documento-sede/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentos: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentos', 'id', id)
            const localVarPath = `/documentos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los socios de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocios: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocios', 'id', id)
            const localVarPath = `/socio/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentosApi - functional programming interface
 * @export
 */
export const DocumentosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentosApiAxiosParamCreator(configuration)
    return {
        /**
         * Crear un nuevo documento para el registro del representante
         * @param {number} id Identificador único
         * @param {DocumentoRepresentante} documentoRepresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoRepresentante(id: number, documentoRepresentante: DocumentoRepresentante, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoRepresentante(id, documentoRepresentante, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo documento para el registro de sede
         * @param {number} id Identificador único
         * @param {DocumentoSede} documentoSede 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoSede(id: number, documentoSede: DocumentoSede, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoSede(id, documentoSede, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo socio de un documento creación
         * @param {number} id Identificador único
         * @param {Socio} socio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSocio(id: number, socio: Socio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSocio(id, socio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un socio de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSocio(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSocio(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el documento del representante
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentoRepresentante(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoRepresentante>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentoRepresentante(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el documento de un registro de sede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentoSede(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoSede>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentoSede(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentos(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListaDocumentos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentos(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los socios de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocios(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Socio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocios(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentosApi - factory interface
 * @export
 */
export const DocumentosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentosApiFp(configuration)
    return {
        /**
         * Crear un nuevo documento para el registro del representante
         * @param {number} id Identificador único
         * @param {DocumentoRepresentante} documentoRepresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoRepresentante(id: number, documentoRepresentante: DocumentoRepresentante, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoRepresentante(id, documentoRepresentante, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo documento para el registro de sede
         * @param {number} id Identificador único
         * @param {DocumentoSede} documentoSede 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoSede(id: number, documentoSede: DocumentoSede, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoSede(id, documentoSede, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo socio de un documento creación
         * @param {number} id Identificador único
         * @param {Socio} socio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSocio(id: number, socio: Socio, options?: any): AxiosPromise<void> {
            return localVarFp.createSocio(id, socio, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un socio de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSocio(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSocio(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el documento del representante
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoRepresentante(id: number, options?: any): AxiosPromise<DocumentoRepresentante> {
            return localVarFp.getDocumentoRepresentante(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el documento de un registro de sede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoSede(id: number, options?: any): AxiosPromise<DocumentoSede> {
            return localVarFp.getDocumentoSede(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentos(id: number, options?: any): AxiosPromise<ListaDocumentos> {
            return localVarFp.getDocumentos(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los socios de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocios(id: number, options?: any): AxiosPromise<Array<Socio>> {
            return localVarFp.getSocios(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentosApi - object-oriented interface
 * @export
 * @class DocumentosApi
 * @extends {BaseAPI}
 */
export class DocumentosApi extends BaseAPI {
    /**
     * Crear un nuevo documento para el registro del representante
     * @param {number} id Identificador único
     * @param {DocumentoRepresentante} documentoRepresentante 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public createDocumentoRepresentante(id: number, documentoRepresentante: DocumentoRepresentante, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).createDocumentoRepresentante(id, documentoRepresentante, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo documento para el registro de sede
     * @param {number} id Identificador único
     * @param {DocumentoSede} documentoSede 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public createDocumentoSede(id: number, documentoSede: DocumentoSede, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).createDocumentoSede(id, documentoSede, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo socio de un documento creación
     * @param {number} id Identificador único
     * @param {Socio} socio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public createSocio(id: number, socio: Socio, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).createSocio(id, socio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un socio de un documento creación
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public deleteSocio(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).deleteSocio(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el documento del representante
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public getDocumentoRepresentante(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).getDocumentoRepresentante(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el documento de un registro de sede
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public getDocumentoSede(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).getDocumentoSede(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public getDocumentos(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).getDocumentos(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los socios de un documento creación
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public getSocios(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).getSocios(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobApi - axios parameter creator
 * @export
 */
export const JobApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getjobStatus', 'id', id)
            const localVarPath = `/reniecyt-job/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobApi - functional programming interface
 * @export
 */
export const JobApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobApiAxiosParamCreator(configuration)
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getjobStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getjobStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobApi - factory interface
 * @export
 */
export const JobApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobApiFp(configuration)
    return {
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getjobStatus(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobApi - object-oriented interface
 * @export
 * @class JobApi
 * @extends {BaseAPI}
 */
export class JobApi extends BaseAPI {
    /**
     * Recupera el estado del job de jobrunr
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    public getjobStatus(id: string, options?: AxiosRequestConfig) {
        return JobApiFp(this.configuration).getjobStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PersonaApi - axios parameter creator
 * @export
 */
export const PersonaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene una persona basada en su ID
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersona: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getPersona', 'idPersona', idPersona)
            const localVarPath = `/persona/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonaApi - functional programming interface
 * @export
 */
export const PersonaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonaApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtiene una persona basada en su ID
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersona(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Persona>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersona(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PersonaApi - factory interface
 * @export
 */
export const PersonaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonaApiFp(configuration)
    return {
        /**
         * Obtiene una persona basada en su ID
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersona(idPersona: number, options?: any): AxiosPromise<Persona> {
            return localVarFp.getPersona(idPersona, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonaApi - object-oriented interface
 * @export
 * @class PersonaApi
 * @extends {BaseAPI}
 */
export class PersonaApi extends BaseAPI {
    /**
     * Obtiene una persona basada en su ID
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonaApi
     */
    public getPersona(idPersona: number, options?: AxiosRequestConfig) {
        return PersonaApiFp(this.configuration).getPersona(idPersona, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegistroApi - axios parameter creator
 * @export
 */
export const RegistroApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Actualiza los datos de institucion de una sede dado su id.
         * @param {number} idRegistro Identificador único del registro
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaDatosInstitucion: async (idRegistro: number, inlineObject: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaDatosInstitucion', 'idRegistro', idRegistro)
            // verify required parameter 'inlineObject' is not null or undefined
            assertParamExists('actualizaDatosInstitucion', 'inlineObject', inlineObject)
            const localVarPath = `/registro/{idRegistro}/actualiza-datos-institucion`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza el estado de un registro en base al ID del registro.
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaEstatusCaptura: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaEstatusCaptura', 'idRegistro', idRegistro)
            const localVarPath = `/registro/{idRegistro}/actualiza-estatus-captura`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
         * @param {number} idRegistro Identificador único del registro
         * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
         * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaRegistroObservaciones: async (idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaRegistroObservaciones', 'idRegistro', idRegistro)
            // verify required parameter 'estado' is not null or undefined
            assertParamExists('actualizaRegistroObservaciones', 'estado', estado)
            const localVarPath = `/registro/actualiza/observaciones/{idRegistro}/{estado}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)))
                .replace(`{${"estado"}}`, encodeURIComponent(String(estado)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comentarioRechazoSolicitud, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaSector: async (idRegistro: number, sector: Sector, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaSector', 'idRegistro', idRegistro)
            // verify required parameter 'sector' is not null or undefined
            assertParamExists('actualizaSector', 'sector', sector)
            const localVarPath = `/registro/actualiza/sector/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sector, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asignar un registro a un revisor
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsignacionRevisor: async (idRegistro: number, cvuRevisor?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createAsignacionRevisor', 'idRegistro', idRegistro)
            const localVarPath = `/registro/revisor/asignacion/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (cvuRevisor !== undefined) {
                localVarQueryParameter['cvuRevisor'] = cvuRevisor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo documento de creación
         * @param {number} id Identificador único
         * @param {DocumentoCreacion} documentoCreacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocuementoCreacion: async (id: number, documentoCreacion: DocumentoCreacion, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocuementoCreacion', 'id', id)
            // verify required parameter 'documentoCreacion' is not null or undefined
            assertParamExists('createDocuementoCreacion', 'documentoCreacion', documentoCreacion)
            const localVarPath = `/documento-creacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoCreacion, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
         * @param {number} id Identificador único
         * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoCancelacionIncumplimiento: async (id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocumentoCancelacionIncumplimiento', 'id', id)
            // verify required parameter 'documentoCancelacionIncumplimiento' is not null or undefined
            assertParamExists('createDocumentoCancelacionIncumplimiento', 'documentoCancelacionIncumplimiento', documentoCancelacionIncumplimiento)
            const localVarPath = `/documento-cancelacion-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoCancelacionIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
         * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoIncumplimiento: async (documentoIncumplimiento: Array<DocumentoIncumplimiento>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentoIncumplimiento' is not null or undefined
            assertParamExists('createDocumentoIncumplimiento', 'documentoIncumplimiento', documentoIncumplimiento)
            const localVarPath = `/documento-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo domicilio de un residencial
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomicilioResidencial: async (id: number, registroDomicilio: RegistroDomicilio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDomicilioResidencial', 'id', id)
            // verify required parameter 'registroDomicilio' is not null or undefined
            assertParamExists('createDomicilioResidencial', 'registroDomicilio', registroDomicilio)
            const localVarPath = `/domicilio-residencial/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registroDomicilio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedioContacto: async (idPersona: number, idRegistro: number, medioContacto: MedioContacto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createMedioContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createMedioContacto', 'idRegistro', idRegistro)
            // verify required parameter 'medioContacto' is not null or undefined
            assertParamExists('createMedioContacto', 'medioContacto', medioContacto)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medioContacto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediosContacto: async (idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createMediosContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createMediosContacto', 'idRegistro', idRegistro)
            // verify required parameter 'medioContacto' is not null or undefined
            assertParamExists('createMediosContacto', 'medioContacto', medioContacto)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}/bulk`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medioContacto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear una nueva subsede
         * @param {number} idSede Identificador de la sede padre
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevaSubsede: async (idSede: number, nuevoRegistro: NuevoRegistro, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSede' is not null or undefined
            assertParamExists('createNuevaSubsede', 'idSede', idSede)
            // verify required parameter 'nuevoRegistro' is not null or undefined
            assertParamExists('createNuevaSubsede', 'nuevoRegistro', nuevoRegistro)
            const localVarPath = `/subsede/{idSede}`
                .replace(`{${"idSede"}}`, encodeURIComponent(String(idSede)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nuevoRegistro, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevoRegistro: async (nuevoRegistro: NuevoRegistro, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nuevoRegistro' is not null or undefined
            assertParamExists('createNuevoRegistro', 'nuevoRegistro', nuevoRegistro)
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nuevoRegistro, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nueva persona registro
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonaRegistro: async (id: number, persona: Persona, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPersonaRegistro', 'id', id)
            // verify required parameter 'persona' is not null or undefined
            assertParamExists('createPersonaRegistro', 'persona', persona)
            const localVarPath = `/persona-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persona, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {Plataforma} plataforma 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlataformas: async (plataforma: Plataforma, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plataforma' is not null or undefined
            assertParamExists('createPlataformas', 'plataforma', plataforma)
            const localVarPath = `/plataformas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plataforma, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un poder otrogado para una persona
         * @param {number} idPersona Identificador de la persona
         * @param {PoderOtorgado} poderOtorgado 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPoderOtorgado: async (idPersona: number, poderOtorgado: PoderOtorgado, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createPoderOtorgado', 'idPersona', idPersona)
            // verify required parameter 'poderOtorgado' is not null or undefined
            assertParamExists('createPoderOtorgado', 'poderOtorgado', poderOtorgado)
            const localVarPath = `/poder-otorgado/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poderOtorgado, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroAnotaciones: async (anotacionesIncumplimiento: AnotacionesIncumplimiento, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anotacionesIncumplimiento' is not null or undefined
            assertParamExists('createRegistroAnotaciones', 'anotacionesIncumplimiento', anotacionesIncumplimiento)
            const localVarPath = `/anotaciones-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anotacionesIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro de cancelacion de incumplimiento
         * @param {number} id Identificador único
         * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroCancelacionIncumplimiento: async (id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createRegistroCancelacionIncumplimiento', 'id', id)
            // verify required parameter 'registroCancelacionIncumplimiento' is not null or undefined
            assertParamExists('createRegistroCancelacionIncumplimiento', 'registroCancelacionIncumplimiento', registroCancelacionIncumplimiento)
            const localVarPath = `/registro-cancelacion-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registroCancelacionIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo domicilio de un registro
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroDomicilio: async (id: number, registroDomicilio: RegistroDomicilio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createRegistroDomicilio', 'id', id)
            // verify required parameter 'registroDomicilio' is not null or undefined
            assertParamExists('createRegistroDomicilio', 'registroDomicilio', registroDomicilio)
            const localVarPath = `/domicilio-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registroDomicilio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {Subsistema} subsistema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubsistemas: async (subsistema: Subsistema, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subsistema' is not null or undefined
            assertParamExists('createSubsistemas', 'subsistema', subsistema)
            const localVarPath = `/subsistemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subsistema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina una asignación de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsignacionRevisor: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteAsignacionRevisor', 'idRegistro', idRegistro)
            const localVarPath = `/registro/revisor/asignacion/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistro: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteRegistro', 'idRegistro', idRegistro)
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idRegistro !== undefined) {
                localVarQueryParameter['idRegistro'] = idRegistro;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistroSubsede: async (idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteRegistroSubsede', 'idRegistro', idRegistro)
            // verify required parameter 'esAdmin' is not null or undefined
            assertParamExists('deleteRegistroSubsede', 'esAdmin', esAdmin)
            // verify required parameter 'inlineObject2' is not null or undefined
            assertParamExists('deleteRegistroSubsede', 'inlineObject2', inlineObject2)
            const localVarPath = `/subsede`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idRegistro !== undefined) {
                localVarQueryParameter['idRegistro'] = idRegistro;
            }

            if (esAdmin !== undefined) {
                localVarQueryParameter['esAdmin'] = esAdmin;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un representante
         * @param {number} idRegistro Identificador único del registro
         * @param {number} idPersona Identificador de la persona
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRepresentante: async (idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteRepresentante', 'idRegistro', idRegistro)
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('deleteRepresentante', 'idPersona', idPersona)
            const localVarPath = `/persona-registro/{idRegistro}/elimina-representante/{idPersona}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)))
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviaRegistro: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enviaRegistro', 'id', id)
            const localVarPath = `/registro/envia/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioPersonaRegistro: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getComentarioPersonaRegistro', 'idPersona', idPersona)
            const localVarPath = `/persona-registro/comentario/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioTemporalRegistro: async (idRegistroEstatus: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistroEstatus' is not null or undefined
            assertParamExists('getComentarioTemporalRegistro', 'idRegistroEstatus', idRegistroEstatus)
            const localVarPath = `/registro/comentarioTemporales/{idRegistroEstatus}`
                .replace(`{${"idRegistroEstatus"}}`, encodeURIComponent(String(idRegistroEstatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentariosRegistro: async (idRegistro: number, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getComentariosRegistro', 'idRegistro', idRegistro)
            const localVarPath = `/registro/{idRegistro}/comentarios`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener la informacion de los datos de actualizacion de una sede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosActualizadosInstitucion: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getDatosActualizadosInstitucion', 'idRegistro', idRegistro)
            const localVarPath = `/registro/{idRegistro}/actualiza-datos-institucion`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener la informacion de los datos de eliminacion de una subsede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosEliminacionSubsede: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getDatosEliminacionSubsede', 'idRegistro', idRegistro)
            const localVarPath = `/subsede/datos-eliminacion/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosGenerales: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatosGenerales', 'id', id)
            const localVarPath = `/datos-generales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el documento de creacion
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoCreacion: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentoCreacion', 'id', id)
            const localVarPath = `/documento-creacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los documentos de anotaciones de incumplimiento
         * @param {number} idIncumplimiento ID del incumplimiento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosIncumplimiento: async (idIncumplimiento: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idIncumplimiento' is not null or undefined
            assertParamExists('getDocumentosIncumplimiento', 'idIncumplimiento', idIncumplimiento)
            const localVarPath = `/documento-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idIncumplimiento !== undefined) {
                localVarQueryParameter['idIncumplimiento'] = idIncumplimiento;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el domicilio de un residencial
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomicilioResidencial: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDomicilioResidencial', 'id', id)
            const localVarPath = `/domicilio-residencial/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el valor booleano en caso de tener o no un registro de persona física
         * @param {string} [cvu] cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRegistrofisica: async (cvu?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/existe-registro-fisica`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (cvu !== undefined) {
                localVarQueryParameter['cvu'] = cvu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el valor booleano en caso de existir o no un rfc
         * @param {string} rfc rfc del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRfc: async (rfc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rfc' is not null or undefined
            assertParamExists('getExisteRfc', 'rfc', rfc)
            const localVarPath = `/existe-rfc/{rfc}`
                .replace(`{${"rfc"}}`, encodeURIComponent(String(rfc)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitucionSnp: async (noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro/snp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (noDeRegistroQuery !== undefined) {
                localVarQueryParameter['noDeRegistroQuery'] = noDeRegistroQuery;
            }

            if (rfcQuery !== undefined) {
                localVarQueryParameter['rfcQuery'] = rfcQuery;
            }

            if (tipoSolicitud !== undefined) {
                localVarQueryParameter['tipoSolicitud'] = tipoSolicitud;
            }

            if (sector !== undefined) {
                localVarQueryParameter['sector'] = sector;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener la lista de estatus de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListaEstatus: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getListaEstatus', 'idRegistro', idRegistro)
            const localVarPath = `/registro/lista-estatus/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediosContacto: async (idPersona: number, idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getMediosContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getMediosContacto', 'idRegistro', idRegistro)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener a los representantes legales
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaRegistros: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonaRegistros', 'id', id)
            const localVarPath = `/persona-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de plataformas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlataformas: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/plataformas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Método utilizado para recuperar el poder otorgado a una persona
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoderOtorgado: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getPoderOtorgado', 'idPersona', idPersona)
            const localVarPath = `/poder-otorgado/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroAnotacion: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistroAnotacion', 'id', id)
            const localVarPath = `/anotaciones-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener un registro de cancelación de incumplimiento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroCancelacionIncumplimiento: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistroCancelacionIncumplimiento', 'id', id)
            const localVarPath = `/registro-cancelacion-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el domicilio de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroDomicilio: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistroDomicilio', 'id', id)
            const localVarPath = `/domicilio-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de un CVU
         * @param {string} [cvu] cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroSolicitudes: async (cvu?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (cvu !== undefined) {
                localVarQueryParameter['cvu'] = cvu;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {string} [numeroOficio] Número de oficio.
         * @param {string} [numeroFolio] Número de folio.
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosAnotaciones: async (numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/anotaciones-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (numeroOficio !== undefined) {
                localVarQueryParameter['numeroOficio'] = numeroOficio;
            }

            if (numeroFolio !== undefined) {
                localVarQueryParameter['numeroFolio'] = numeroFolio;
            }

            if (cvuRepLegal !== undefined) {
                localVarQueryParameter['cvuRepLegal'] = cvuRepLegal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {number} [estatusRegistroQuery] Estatus del registro.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {string} [nombreRepLegal] nombre del representante legal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosRevisor: async (rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro/revisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (rfcQuery !== undefined) {
                localVarQueryParameter['rfcQuery'] = rfcQuery;
            }

            if (empresaInstitucionQuery !== undefined) {
                localVarQueryParameter['empresaInstitucionQuery'] = empresaInstitucionQuery;
            }

            if (noDeRegistroQuery !== undefined) {
                localVarQueryParameter['noDeRegistroQuery'] = noDeRegistroQuery;
            }

            if (estatusRegistroQuery !== undefined) {
                localVarQueryParameter['estatusRegistroQuery'] = estatusRegistroQuery;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (cvuRevisor !== undefined) {
                localVarQueryParameter['cvuRevisor'] = cvuRevisor;
            }

            if (misAsignaciones !== undefined) {
                localVarQueryParameter['misAsignaciones'] = misAsignaciones;
            }

            if (esAdmin !== undefined) {
                localVarQueryParameter['esAdmin'] = esAdmin;
            }

            if (cvuRepLegal !== undefined) {
                localVarQueryParameter['cvuRepLegal'] = cvuRepLegal;
            }

            if (nombreRepLegal !== undefined) {
                localVarQueryParameter['nombreRepLegal'] = nombreRepLegal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exportar pdf registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReporteRegistro: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getReporteRegistro', 'idRegistro', idRegistro)
            const localVarPath = `/registro/pdf/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todas las subsedes de un registro
         * @param {number} idSede Identificador de la sede padre
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedes: async (idSede: number, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSede' is not null or undefined
            assertParamExists('getSubsedes', 'idSede', idSede)
            const localVarPath = `/subsede/{idSede}`
                .replace(`{${"idSede"}}`, encodeURIComponent(String(idSede)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todas las subsedes asociadas a un cvu
         * @param {string} cvu Cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesByCvu: async (cvu: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            assertParamExists('getSubsedesByCvu', 'cvu', cvu)
            const localVarPath = `/subsede`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (cvu !== undefined) {
                localVarQueryParameter['cvu'] = cvu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todas las subsedes
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [noRegistro] No de Registro de la subsede
         * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
         * @param {number} [estatus] Estatus de la subsede
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesRevisor: async (page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subsede/revisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (cvuRevisor !== undefined) {
                localVarQueryParameter['cvuRevisor'] = cvuRevisor;
            }

            if (misAsignaciones !== undefined) {
                localVarQueryParameter['misAsignaciones'] = misAsignaciones;
            }

            if (esAdmin !== undefined) {
                localVarQueryParameter['esAdmin'] = esAdmin;
            }

            if (noRegistro !== undefined) {
                localVarQueryParameter['noRegistro'] = noRegistro;
            }

            if (empresaInstitucion !== undefined) {
                localVarQueryParameter['empresaInstitucion'] = empresaInstitucion;
            }

            if (estatus !== undefined) {
                localVarQueryParameter['estatus'] = estatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de subsistemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsistemas: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subsistemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los tipos de usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipoUsuario: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tipo-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarComentarioTemporal: async (comentarioRegistroEstatus: ComentarioRegistroEstatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comentarioRegistroEstatus' is not null or undefined
            assertParamExists('guardarComentarioTemporal', 'comentarioRegistroEstatus', comentarioRegistroEstatus)
            const localVarPath = `/registro/comentarioTemporales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comentarioRegistroEstatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza la informacion de una persona
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersona: async (id: number, persona: Persona, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePersona', 'id', id)
            // verify required parameter 'persona' is not null or undefined
            assertParamExists('updatePersona', 'persona', persona)
            const localVarPath = `/persona-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persona, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza un registro
         * @param {number} idRegistro Id del registro
         * @param {ActualizaRegistro} actualizaRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegistro: async (idRegistro: number, actualizaRegistro: ActualizaRegistro, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('updateRegistro', 'idRegistro', idRegistro)
            // verify required parameter 'actualizaRegistro' is not null or undefined
            assertParamExists('updateRegistro', 'actualizaRegistro', actualizaRegistro)
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idRegistro !== undefined) {
                localVarQueryParameter['idRegistro'] = idRegistro;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actualizaRegistro, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDatosGenerales: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDatosGenerales', 'id', id)
            const localVarPath = `/datos-generales/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoCreacion: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDocumentoCreacion', 'id', id)
            const localVarPath = `/documento-creacion/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoRepresentante: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDocumentoRepresentante', 'id', id)
            const localVarPath = `/documento-representante/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoSede: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDocumentoSede', 'id', id)
            const localVarPath = `/documento-sede/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioRegistro: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDomicilioRegistro', 'id', id)
            const localVarPath = `/domicilio-registro/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioResidencial: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDomicilioResidencial', 'id', id)
            const localVarPath = `/domicilio-residencial/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaPoderOtorgado: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaPoderOtorgado', 'id', id)
            const localVarPath = `/poder-otorgado/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener una lista de la validación de cada subsede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaSubsedes: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaSubsedes', 'id', id)
            const localVarPath = `/subsede/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistroApi - functional programming interface
 * @export
 */
export const RegistroApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistroApiAxiosParamCreator(configuration)
    return {
        /**
         * Actualiza los datos de institucion de una sede dado su id.
         * @param {number} idRegistro Identificador único del registro
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaDatosInstitucion(idRegistro: number, inlineObject: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaDatosInstitucion(idRegistro, inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza el estado de un registro en base al ID del registro.
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaEstatusCaptura(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaEstatusCaptura(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
         * @param {number} idRegistro Identificador único del registro
         * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
         * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaRegistroObservaciones(idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaRegistroObservaciones(idRegistro, estado, comentarioRechazoSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaSector(idRegistro: number, sector: Sector, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaSector(idRegistro, sector, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Asignar un registro a un revisor
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsignacionRevisor(idRegistro: number, cvuRevisor?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsignacionRevisor(idRegistro, cvuRevisor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo documento de creación
         * @param {number} id Identificador único
         * @param {DocumentoCreacion} documentoCreacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocuementoCreacion(id: number, documentoCreacion: DocumentoCreacion, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocuementoCreacion(id, documentoCreacion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
         * @param {number} id Identificador único
         * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoCancelacionIncumplimiento(id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoCancelacionIncumplimiento(id, documentoCancelacionIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
         * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoIncumplimiento(documentoIncumplimiento: Array<DocumentoIncumplimiento>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoIncumplimiento(documentoIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo domicilio de un residencial
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDomicilioResidencial(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDomicilioResidencial(id, registroDomicilio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedioContacto(idPersona, idRegistro, medioContacto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMediosContacto(idPersona, idRegistro, medioContacto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear una nueva subsede
         * @param {number} idSede Identificador de la sede padre
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNuevaSubsede(idSede: number, nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNuevaSubsede(idSede, nuevoRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNuevoRegistro(nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNuevoRegistro(nuevoRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nueva persona registro
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonaRegistro(id: number, persona: Persona, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonaRegistro(id, persona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {Plataforma} plataforma 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlataformas(plataforma: Plataforma, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlataformas(plataforma, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un poder otrogado para una persona
         * @param {number} idPersona Identificador de la persona
         * @param {PoderOtorgado} poderOtorgado 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPoderOtorgado(idPersona: number, poderOtorgado: PoderOtorgado, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPoderOtorgado(idPersona, poderOtorgado, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistroAnotaciones(anotacionesIncumplimiento: AnotacionesIncumplimiento, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistroAnotaciones(anotacionesIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro de cancelacion de incumplimiento
         * @param {number} id Identificador único
         * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistroCancelacionIncumplimiento(id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistroCancelacionIncumplimiento(id, registroCancelacionIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo domicilio de un registro
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistroDomicilio(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistroDomicilio(id, registroDomicilio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {Subsistema} subsistema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubsistemas(subsistema: Subsistema, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubsistemas(subsistema, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina una asignación de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAsignacionRevisor(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsignacionRevisor(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegistro(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegistro(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegistroSubsede(idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegistroSubsede(idRegistro, esAdmin, inlineObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un representante
         * @param {number} idRegistro Identificador único del registro
         * @param {number} idPersona Identificador de la persona
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRepresentante(idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRepresentante(idRegistro, idPersona, inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviaRegistro(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviaRegistro(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentarioPersonaRegistro(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComentarioPersonaRegistro>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentarioPersonaRegistro(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentarioTemporalRegistro(idRegistroEstatus: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComentarioRegistroEstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentarioTemporalRegistro(idRegistroEstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentariosRegistro(idRegistro: number, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComentarioRegistroEstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentariosRegistro(idRegistro, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener la informacion de los datos de actualizacion de una sede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosActualizadosInstitucion(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatosSedeHistorico>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosActualizadosInstitucion(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener la informacion de los datos de eliminacion de una subsede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosEliminacionSubsede(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosEliminacionSubsede>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosEliminacionSubsede(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosGenerales(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultaRegistro>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosGenerales(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el documento de creacion
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentoCreacion(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoCreacion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentoCreacion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los documentos de anotaciones de incumplimiento
         * @param {number} idIncumplimiento ID del incumplimiento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentosIncumplimiento(idIncumplimiento: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentoIncumplimiento>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentosIncumplimiento(idIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el domicilio de un residencial
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDomicilioResidencial(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroDomicilio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDomicilioResidencial(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el valor booleano en caso de tener o no un registro de persona física
         * @param {string} [cvu] cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExisteRegistrofisica(cvu?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExisteRegistrofisica(cvu, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el valor booleano en caso de existir o no un rfc
         * @param {string} rfc rfc del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExisteRfc(rfc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExisteRfc(rfc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InstitucionSnp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener la lista de estatus de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListaEstatus(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistroEstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListaEstatus(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediosContacto(idPersona: number, idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MedioContacto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediosContacto(idPersona, idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener a los representantes legales
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonaRegistros(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Persona>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonaRegistros(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de plataformas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlataformas(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Plataforma>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlataformas(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Método utilizado para recuperar el poder otorgado a una persona
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPoderOtorgado(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoderOtorgado>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPoderOtorgado(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroAnotacion(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnotacionesIncumplimiento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroAnotacion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener un registro de cancelación de incumplimiento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroCancelacionIncumplimiento(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroCancelacionIncumplimiento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroCancelacionIncumplimiento(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el domicilio de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroDomicilio(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroDomicilio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroDomicilio(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de un CVU
         * @param {string} [cvu] cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroSolicitudes(cvu?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroSolicitudes(cvu, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {string} [numeroOficio] Número de oficio.
         * @param {string} [numeroFolio] Número de folio.
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrosAnotaciones(numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnotacionesIncumplimiento>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrosAnotaciones(numeroOficio, numeroFolio, cvuRepLegal, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {number} [estatusRegistroQuery] Estatus del registro.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {string} [nombreRepLegal] nombre del representante legal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrosRevisor(rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrosRevisor(rfcQuery, empresaInstitucionQuery, noDeRegistroQuery, estatusRegistroQuery, page, size, cvuRevisor, misAsignaciones, esAdmin, cvuRepLegal, nombreRepLegal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Exportar pdf registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReporteRegistro(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoExport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReporteRegistro(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todas las subsedes de un registro
         * @param {number} idSede Identificador de la sede padre
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsedes(idSede: number, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsedes(idSede, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todas las subsedes asociadas a un cvu
         * @param {string} cvu Cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsedesByCvu(cvu: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsedesByCvu(cvu, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todas las subsedes
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [noRegistro] No de Registro de la subsede
         * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
         * @param {number} [estatus] Estatus de la subsede
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsedesRevisor(page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsedesRevisor(page, size, cvuRevisor, misAsignaciones, esAdmin, noRegistro, empresaInstitucion, estatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de subsistemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsistemas(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Subsistema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsistemas(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los tipos de usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTipoUsuario(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TipoUsuario>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTipoUsuario(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarComentarioTemporal(comentarioRegistroEstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza la informacion de una persona
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersona(id: number, persona: Persona, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersona(id, persona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza un registro
         * @param {number} idRegistro Id del registro
         * @param {ActualizaRegistro} actualizaRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRegistro(idRegistro: number, actualizaRegistro: ActualizaRegistro, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRegistro(idRegistro, actualizaRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDatosGenerales(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDatosGenerales(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentoCreacion(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDocumentoCreacion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentoRepresentante(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDocumentoRepresentante(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentoSede(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDocumentoSede(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDomicilioRegistro(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDomicilioRegistro(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDomicilioResidencial(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDomicilioResidencial(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaPoderOtorgado(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaPoderOtorgado(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener una lista de la validación de cada subsede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaSubsedes(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidateSubsede>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaSubsedes(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistroApi - factory interface
 * @export
 */
export const RegistroApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistroApiFp(configuration)
    return {
        /**
         * Actualiza los datos de institucion de una sede dado su id.
         * @param {number} idRegistro Identificador único del registro
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaDatosInstitucion(idRegistro: number, inlineObject: InlineObject, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaDatosInstitucion(idRegistro, inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza el estado de un registro en base al ID del registro.
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaEstatusCaptura(idRegistro: number, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaEstatusCaptura(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
         * @param {number} idRegistro Identificador único del registro
         * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
         * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaRegistroObservaciones(idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaRegistroObservaciones(idRegistro, estado, comentarioRechazoSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaSector(idRegistro: number, sector: Sector, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaSector(idRegistro, sector, options).then((request) => request(axios, basePath));
        },
        /**
         * Asignar un registro a un revisor
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsignacionRevisor(idRegistro: number, cvuRevisor?: number, options?: any): AxiosPromise<void> {
            return localVarFp.createAsignacionRevisor(idRegistro, cvuRevisor, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo documento de creación
         * @param {number} id Identificador único
         * @param {DocumentoCreacion} documentoCreacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocuementoCreacion(id: number, documentoCreacion: DocumentoCreacion, options?: any): AxiosPromise<void> {
            return localVarFp.createDocuementoCreacion(id, documentoCreacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
         * @param {number} id Identificador único
         * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoCancelacionIncumplimiento(id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoCancelacionIncumplimiento(id, documentoCancelacionIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
         * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoIncumplimiento(documentoIncumplimiento: Array<DocumentoIncumplimiento>, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoIncumplimiento(documentoIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo domicilio de un residencial
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomicilioResidencial(id: number, registroDomicilio: RegistroDomicilio, options?: any): AxiosPromise<void> {
            return localVarFp.createDomicilioResidencial(id, registroDomicilio, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: any): AxiosPromise<void> {
            return localVarFp.createMedioContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: any): AxiosPromise<void> {
            return localVarFp.createMediosContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear una nueva subsede
         * @param {number} idSede Identificador de la sede padre
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevaSubsede(idSede: number, nuevoRegistro: NuevoRegistro, options?: any): AxiosPromise<void> {
            return localVarFp.createNuevaSubsede(idSede, nuevoRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevoRegistro(nuevoRegistro: NuevoRegistro, options?: any): AxiosPromise<void> {
            return localVarFp.createNuevoRegistro(nuevoRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nueva persona registro
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonaRegistro(id: number, persona: Persona, options?: any): AxiosPromise<void> {
            return localVarFp.createPersonaRegistro(id, persona, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {Plataforma} plataforma 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlataformas(plataforma: Plataforma, options?: any): AxiosPromise<void> {
            return localVarFp.createPlataformas(plataforma, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un poder otrogado para una persona
         * @param {number} idPersona Identificador de la persona
         * @param {PoderOtorgado} poderOtorgado 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPoderOtorgado(idPersona: number, poderOtorgado: PoderOtorgado, options?: any): AxiosPromise<void> {
            return localVarFp.createPoderOtorgado(idPersona, poderOtorgado, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroAnotaciones(anotacionesIncumplimiento: AnotacionesIncumplimiento, options?: any): AxiosPromise<void> {
            return localVarFp.createRegistroAnotaciones(anotacionesIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro de cancelacion de incumplimiento
         * @param {number} id Identificador único
         * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroCancelacionIncumplimiento(id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options?: any): AxiosPromise<void> {
            return localVarFp.createRegistroCancelacionIncumplimiento(id, registroCancelacionIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo domicilio de un registro
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroDomicilio(id: number, registroDomicilio: RegistroDomicilio, options?: any): AxiosPromise<void> {
            return localVarFp.createRegistroDomicilio(id, registroDomicilio, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {Subsistema} subsistema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubsistemas(subsistema: Subsistema, options?: any): AxiosPromise<void> {
            return localVarFp.createSubsistemas(subsistema, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina una asignación de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsignacionRevisor(idRegistro: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAsignacionRevisor(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistro(idRegistro: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRegistro(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistroSubsede(idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRegistroSubsede(idRegistro, esAdmin, inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un representante
         * @param {number} idRegistro Identificador único del registro
         * @param {number} idPersona Identificador de la persona
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRepresentante(idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRepresentante(idRegistro, idPersona, inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviaRegistro(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.enviaRegistro(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioPersonaRegistro(idPersona: number, options?: any): AxiosPromise<ComentarioPersonaRegistro> {
            return localVarFp.getComentarioPersonaRegistro(idPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioTemporalRegistro(idRegistroEstatus: number, options?: any): AxiosPromise<ComentarioRegistroEstatus> {
            return localVarFp.getComentarioTemporalRegistro(idRegistroEstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentariosRegistro(idRegistro: number, page?: number, size?: number, options?: any): AxiosPromise<Array<ComentarioRegistroEstatus>> {
            return localVarFp.getComentariosRegistro(idRegistro, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener la informacion de los datos de actualizacion de una sede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosActualizadosInstitucion(idRegistro: number, options?: any): AxiosPromise<Array<DatosSedeHistorico>> {
            return localVarFp.getDatosActualizadosInstitucion(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener la informacion de los datos de eliminacion de una subsede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosEliminacionSubsede(idRegistro: number, options?: any): AxiosPromise<DatosEliminacionSubsede> {
            return localVarFp.getDatosEliminacionSubsede(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosGenerales(id: number, options?: any): AxiosPromise<ConsultaRegistro> {
            return localVarFp.getDatosGenerales(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el documento de creacion
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoCreacion(id: number, options?: any): AxiosPromise<DocumentoCreacion> {
            return localVarFp.getDocumentoCreacion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los documentos de anotaciones de incumplimiento
         * @param {number} idIncumplimiento ID del incumplimiento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosIncumplimiento(idIncumplimiento: number, options?: any): AxiosPromise<Array<DocumentoIncumplimiento>> {
            return localVarFp.getDocumentosIncumplimiento(idIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el domicilio de un residencial
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomicilioResidencial(id: number, options?: any): AxiosPromise<RegistroDomicilio> {
            return localVarFp.getDomicilioResidencial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el valor booleano en caso de tener o no un registro de persona física
         * @param {string} [cvu] cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRegistrofisica(cvu?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.getExisteRegistrofisica(cvu, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el valor booleano en caso de existir o no un rfc
         * @param {string} rfc rfc del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRfc(rfc: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.getExisteRfc(rfc, options).then((request) => request(axios, basePath));
        },
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<InstitucionSnp>> {
            return localVarFp.getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener la lista de estatus de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListaEstatus(idRegistro: number, options?: any): AxiosPromise<Array<RegistroEstatus>> {
            return localVarFp.getListaEstatus(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediosContacto(idPersona: number, idRegistro: number, options?: any): AxiosPromise<Array<MedioContacto>> {
            return localVarFp.getMediosContacto(idPersona, idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener a los representantes legales
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaRegistros(id: number, options?: any): AxiosPromise<Array<Persona>> {
            return localVarFp.getPersonaRegistros(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de plataformas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlataformas(options?: any): AxiosPromise<Array<Plataforma>> {
            return localVarFp.getPlataformas(options).then((request) => request(axios, basePath));
        },
        /**
         * Método utilizado para recuperar el poder otorgado a una persona
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoderOtorgado(idPersona: number, options?: any): AxiosPromise<PoderOtorgado> {
            return localVarFp.getPoderOtorgado(idPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroAnotacion(id: number, options?: any): AxiosPromise<AnotacionesIncumplimiento> {
            return localVarFp.getRegistroAnotacion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener un registro de cancelación de incumplimiento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroCancelacionIncumplimiento(id: number, options?: any): AxiosPromise<RegistroCancelacionIncumplimiento> {
            return localVarFp.getRegistroCancelacionIncumplimiento(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el domicilio de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroDomicilio(id: number, options?: any): AxiosPromise<RegistroDomicilio> {
            return localVarFp.getRegistroDomicilio(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de un CVU
         * @param {string} [cvu] cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroSolicitudes(cvu?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getRegistroSolicitudes(cvu, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {string} [numeroOficio] Número de oficio.
         * @param {string} [numeroFolio] Número de folio.
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosAnotaciones(numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<AnotacionesIncumplimiento>> {
            return localVarFp.getRegistrosAnotaciones(numeroOficio, numeroFolio, cvuRepLegal, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {number} [estatusRegistroQuery] Estatus del registro.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {string} [nombreRepLegal] nombre del representante legal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosRevisor(rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getRegistrosRevisor(rfcQuery, empresaInstitucionQuery, noDeRegistroQuery, estatusRegistroQuery, page, size, cvuRevisor, misAsignaciones, esAdmin, cvuRepLegal, nombreRepLegal, options).then((request) => request(axios, basePath));
        },
        /**
         * Exportar pdf registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReporteRegistro(idRegistro: number, options?: any): AxiosPromise<DocumentoExport> {
            return localVarFp.getReporteRegistro(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todas las subsedes de un registro
         * @param {number} idSede Identificador de la sede padre
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedes(idSede: number, page?: number, size?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getSubsedes(idSede, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todas las subsedes asociadas a un cvu
         * @param {string} cvu Cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesByCvu(cvu: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getSubsedesByCvu(cvu, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todas las subsedes
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [noRegistro] No de Registro de la subsede
         * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
         * @param {number} [estatus] Estatus de la subsede
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesRevisor(page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getSubsedesRevisor(page, size, cvuRevisor, misAsignaciones, esAdmin, noRegistro, empresaInstitucion, estatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de subsistemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsistemas(options?: any): AxiosPromise<Array<Subsistema>> {
            return localVarFp.getSubsistemas(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los tipos de usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipoUsuario(options?: any): AxiosPromise<Array<TipoUsuario>> {
            return localVarFp.getTipoUsuario(options).then((request) => request(axios, basePath));
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: any): AxiosPromise<void> {
            return localVarFp.guardarComentarioTemporal(comentarioRegistroEstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza la informacion de una persona
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersona(id: number, persona: Persona, options?: any): AxiosPromise<void> {
            return localVarFp.updatePersona(id, persona, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza un registro
         * @param {number} idRegistro Id del registro
         * @param {ActualizaRegistro} actualizaRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegistro(idRegistro: number, actualizaRegistro: ActualizaRegistro, options?: any): AxiosPromise<void> {
            return localVarFp.updateRegistro(idRegistro, actualizaRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDatosGenerales(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDatosGenerales(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoCreacion(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDocumentoCreacion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoRepresentante(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDocumentoRepresentante(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoSede(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDocumentoSede(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioRegistro(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDomicilioRegistro(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioResidencial(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDomicilioResidencial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaPoderOtorgado(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaPoderOtorgado(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener una lista de la validación de cada subsede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaSubsedes(id: number, options?: any): AxiosPromise<Array<ValidateSubsede>> {
            return localVarFp.validaSubsedes(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistroApi - object-oriented interface
 * @export
 * @class RegistroApi
 * @extends {BaseAPI}
 */
export class RegistroApi extends BaseAPI {
    /**
     * Actualiza los datos de institucion de una sede dado su id.
     * @param {number} idRegistro Identificador único del registro
     * @param {InlineObject} inlineObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public actualizaDatosInstitucion(idRegistro: number, inlineObject: InlineObject, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).actualizaDatosInstitucion(idRegistro, inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza el estado de un registro en base al ID del registro.
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public actualizaEstatusCaptura(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).actualizaEstatusCaptura(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
     * @param {number} idRegistro Identificador único del registro
     * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
     * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public actualizaRegistroObservaciones(idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).actualizaRegistroObservaciones(idRegistro, estado, comentarioRechazoSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza La informacion que provenga del objeto sector.
     * @param {number} idRegistro Identificador único del registro
     * @param {Sector} sector 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public actualizaSector(idRegistro: number, sector: Sector, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).actualizaSector(idRegistro, sector, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asignar un registro a un revisor
     * @param {number} idRegistro Identificador único del registro
     * @param {number} [cvuRevisor] Cvu del revisor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createAsignacionRevisor(idRegistro: number, cvuRevisor?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createAsignacionRevisor(idRegistro, cvuRevisor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo documento de creación
     * @param {number} id Identificador único
     * @param {DocumentoCreacion} documentoCreacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createDocuementoCreacion(id: number, documentoCreacion: DocumentoCreacion, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createDocuementoCreacion(id, documentoCreacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
     * @param {number} id Identificador único
     * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createDocumentoCancelacionIncumplimiento(id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createDocumentoCancelacionIncumplimiento(id, documentoCancelacionIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
     * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createDocumentoIncumplimiento(documentoIncumplimiento: Array<DocumentoIncumplimiento>, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createDocumentoIncumplimiento(documentoIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo domicilio de un residencial
     * @param {number} id Identificador único
     * @param {RegistroDomicilio} registroDomicilio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createDomicilioResidencial(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createDomicilioResidencial(id, registroDomicilio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo medio de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {MedioContacto} medioContacto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createMedioContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {Array<MedioContacto>} medioContacto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createMediosContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear una nueva subsede
     * @param {number} idSede Identificador de la sede padre
     * @param {NuevoRegistro} nuevoRegistro 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createNuevaSubsede(idSede: number, nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createNuevaSubsede(idSede, nuevoRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {NuevoRegistro} nuevoRegistro 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createNuevoRegistro(nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createNuevoRegistro(nuevoRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nueva persona registro
     * @param {number} id Identificador único
     * @param {Persona} persona 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createPersonaRegistro(id: number, persona: Persona, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createPersonaRegistro(id, persona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {Plataforma} plataforma 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createPlataformas(plataforma: Plataforma, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createPlataformas(plataforma, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un poder otrogado para una persona
     * @param {number} idPersona Identificador de la persona
     * @param {PoderOtorgado} poderOtorgado 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createPoderOtorgado(idPersona: number, poderOtorgado: PoderOtorgado, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createPoderOtorgado(idPersona, poderOtorgado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createRegistroAnotaciones(anotacionesIncumplimiento: AnotacionesIncumplimiento, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createRegistroAnotaciones(anotacionesIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro de cancelacion de incumplimiento
     * @param {number} id Identificador único
     * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createRegistroCancelacionIncumplimiento(id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createRegistroCancelacionIncumplimiento(id, registroCancelacionIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo domicilio de un registro
     * @param {number} id Identificador único
     * @param {RegistroDomicilio} registroDomicilio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createRegistroDomicilio(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createRegistroDomicilio(id, registroDomicilio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {Subsistema} subsistema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public createSubsistemas(subsistema: Subsistema, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).createSubsistemas(subsistema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina una asignación de un registro
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public deleteAsignacionRevisor(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).deleteAsignacionRevisor(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un registro
     * @param {number} idRegistro Id del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public deleteRegistro(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).deleteRegistro(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un registro
     * @param {number} idRegistro Id del registro
     * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
     * @param {InlineObject2} inlineObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public deleteRegistroSubsede(idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).deleteRegistroSubsede(idRegistro, esAdmin, inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un representante
     * @param {number} idRegistro Identificador único del registro
     * @param {number} idPersona Identificador de la persona
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public deleteRepresentante(idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).deleteRepresentante(idRegistro, idPersona, inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public enviaRegistro(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).enviaRegistro(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el comentario de una persona eliminada
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getComentarioPersonaRegistro(idPersona: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getComentarioPersonaRegistro(idPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los comentarios asociados a un registro
     * @param {number} idRegistroEstatus Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getComentarioTemporalRegistro(idRegistroEstatus: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getComentarioTemporalRegistro(idRegistroEstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los comentarios asociados a un registro
     * @param {number} idRegistro Identificador único del registro
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getComentariosRegistro(idRegistro: number, page?: number, size?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getComentariosRegistro(idRegistro, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener la informacion de los datos de actualizacion de una sede
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getDatosActualizadosInstitucion(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getDatosActualizadosInstitucion(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener la informacion de los datos de eliminacion de una subsede
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getDatosEliminacionSubsede(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getDatosEliminacionSubsede(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getDatosGenerales(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getDatosGenerales(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el documento de creacion
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getDocumentoCreacion(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getDocumentoCreacion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los documentos de anotaciones de incumplimiento
     * @param {number} idIncumplimiento ID del incumplimiento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getDocumentosIncumplimiento(idIncumplimiento: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getDocumentosIncumplimiento(idIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el domicilio de un residencial
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getDomicilioResidencial(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getDomicilioResidencial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el valor booleano en caso de tener o no un registro de persona física
     * @param {string} [cvu] cvu del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getExisteRegistrofisica(cvu?: string, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getExisteRegistrofisica(cvu, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el valor booleano en caso de existir o no un rfc
     * @param {string} rfc rfc del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getExisteRfc(rfc: string, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getExisteRfc(rfc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * obtiene las instituciones y subsedes de SNP
     * @param {string} [noDeRegistroQuery] Número de registro.
     * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
     * @param {string} [tipoSolicitud] ID del tipo de solicitud.
     * @param {string} [sector] Nombre del tipo de sector.
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener la lista de estatus de un registro
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getListaEstatus(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getListaEstatus(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los medios de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getMediosContacto(idPersona: number, idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getMediosContacto(idPersona, idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener a los representantes legales
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getPersonaRegistros(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getPersonaRegistros(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de plataformas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getPlataformas(options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getPlataformas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Método utilizado para recuperar el poder otorgado a una persona
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getPoderOtorgado(idPersona: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getPoderOtorgado(idPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de anotaciones de incumplimiento
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getRegistroAnotacion(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getRegistroAnotacion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener un registro de cancelación de incumplimiento por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getRegistroCancelacionIncumplimiento(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getRegistroCancelacionIncumplimiento(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el domicilio de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getRegistroDomicilio(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getRegistroDomicilio(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de un CVU
     * @param {string} [cvu] cvu del usuario
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getRegistroSolicitudes(cvu?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getRegistroSolicitudes(cvu, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de anotaciones de incumplimiento
     * @param {string} [numeroOficio] Número de oficio.
     * @param {string} [numeroFolio] Número de folio.
     * @param {string} [cvuRepLegal] cvu del representante legal
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getRegistrosAnotaciones(numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getRegistrosAnotaciones(numeroOficio, numeroFolio, cvuRepLegal, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
     * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
     * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
     * @param {string} [noDeRegistroQuery] Número de registro.
     * @param {number} [estatusRegistroQuery] Estatus del registro.
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {number} [cvuRevisor] Cvu del revisor
     * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
     * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
     * @param {string} [cvuRepLegal] cvu del representante legal
     * @param {string} [nombreRepLegal] nombre del representante legal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getRegistrosRevisor(rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getRegistrosRevisor(rfcQuery, empresaInstitucionQuery, noDeRegistroQuery, estatusRegistroQuery, page, size, cvuRevisor, misAsignaciones, esAdmin, cvuRepLegal, nombreRepLegal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exportar pdf registro
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getReporteRegistro(idRegistro: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getReporteRegistro(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todas las subsedes de un registro
     * @param {number} idSede Identificador de la sede padre
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getSubsedes(idSede: number, page?: number, size?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getSubsedes(idSede, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todas las subsedes asociadas a un cvu
     * @param {string} cvu Cvu del usuario
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getSubsedesByCvu(cvu: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getSubsedesByCvu(cvu, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todas las subsedes
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {number} [cvuRevisor] Cvu del revisor
     * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
     * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
     * @param {string} [noRegistro] No de Registro de la subsede
     * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
     * @param {number} [estatus] Estatus de la subsede
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getSubsedesRevisor(page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getSubsedesRevisor(page, size, cvuRevisor, misAsignaciones, esAdmin, noRegistro, empresaInstitucion, estatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de subsistemas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getSubsistemas(options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getSubsistemas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los tipos de usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public getTipoUsuario(options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).getTipoUsuario(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Guarda el comentario temporal
     * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).guardarComentarioTemporal(comentarioRegistroEstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza la informacion de una persona
     * @param {number} id Identificador único
     * @param {Persona} persona 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public updatePersona(id: number, persona: Persona, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).updatePersona(id, persona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza un registro
     * @param {number} idRegistro Id del registro
     * @param {ActualizaRegistro} actualizaRegistro 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public updateRegistro(idRegistro: number, actualizaRegistro: ActualizaRegistro, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).updateRegistro(idRegistro, actualizaRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaDatosGenerales(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaDatosGenerales(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaDocumentoCreacion(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaDocumentoCreacion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaDocumentoRepresentante(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaDocumentoRepresentante(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaDocumentoSede(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaDocumentoSede(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaDomicilioRegistro(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaDomicilioRegistro(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaDomicilioResidencial(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaDomicilioResidencial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaPoderOtorgado(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaPoderOtorgado(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener una lista de la validación de cada subsede
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistroApi
     */
    public validaSubsedes(id: number, options?: AxiosRequestConfig) {
        return RegistroApiFp(this.configuration).validaSubsedes(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReniecytApi - axios parameter creator
 * @export
 */
export const ReniecytApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Actualiza los datos de institucion de una sede dado su id.
         * @param {number} idRegistro Identificador único del registro
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaDatosInstitucion: async (idRegistro: number, inlineObject: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaDatosInstitucion', 'idRegistro', idRegistro)
            // verify required parameter 'inlineObject' is not null or undefined
            assertParamExists('actualizaDatosInstitucion', 'inlineObject', inlineObject)
            const localVarPath = `/registro/{idRegistro}/actualiza-datos-institucion`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza el estado de un registro en base al ID del registro.
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaEstatusCaptura: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaEstatusCaptura', 'idRegistro', idRegistro)
            const localVarPath = `/registro/{idRegistro}/actualiza-estatus-captura`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
         * @param {number} idRegistro Identificador único del registro
         * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
         * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaRegistroObservaciones: async (idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaRegistroObservaciones', 'idRegistro', idRegistro)
            // verify required parameter 'estado' is not null or undefined
            assertParamExists('actualizaRegistroObservaciones', 'estado', estado)
            const localVarPath = `/registro/actualiza/observaciones/{idRegistro}/{estado}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)))
                .replace(`{${"estado"}}`, encodeURIComponent(String(estado)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comentarioRechazoSolicitud, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaSector: async (idRegistro: number, sector: Sector, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaSector', 'idRegistro', idRegistro)
            // verify required parameter 'sector' is not null or undefined
            assertParamExists('actualizaSector', 'sector', sector)
            const localVarPath = `/registro/actualiza/sector/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sector, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Busca registros por número de RENIECYT, RFC o razón social
         * @param {string} [numeroRegistro] Número de RENIECYT del registro
         * @param {string} [rfc] RFC del registro
         * @param {string} [nombreInstitucion] Razón social del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buscarInstitucionReniecyt: async (numeroRegistro?: string, rfc?: string, nombreInstitucion?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reniecyt/buscar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (numeroRegistro !== undefined) {
                localVarQueryParameter['numeroRegistro'] = numeroRegistro;
            }

            if (rfc !== undefined) {
                localVarQueryParameter['rfc'] = rfc;
            }

            if (nombreInstitucion !== undefined) {
                localVarQueryParameter['nombreInstitucion'] = nombreInstitucion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asignar un registro a un revisor
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsignacionRevisor: async (idRegistro: number, cvuRevisor?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createAsignacionRevisor', 'idRegistro', idRegistro)
            const localVarPath = `/registro/revisor/asignacion/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (cvuRevisor !== undefined) {
                localVarQueryParameter['cvuRevisor'] = cvuRevisor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo documento de creación
         * @param {number} id Identificador único
         * @param {DocumentoCreacion} documentoCreacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocuementoCreacion: async (id: number, documentoCreacion: DocumentoCreacion, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocuementoCreacion', 'id', id)
            // verify required parameter 'documentoCreacion' is not null or undefined
            assertParamExists('createDocuementoCreacion', 'documentoCreacion', documentoCreacion)
            const localVarPath = `/documento-creacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoCreacion, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
         * @param {number} id Identificador único
         * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoCancelacionIncumplimiento: async (id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocumentoCancelacionIncumplimiento', 'id', id)
            // verify required parameter 'documentoCancelacionIncumplimiento' is not null or undefined
            assertParamExists('createDocumentoCancelacionIncumplimiento', 'documentoCancelacionIncumplimiento', documentoCancelacionIncumplimiento)
            const localVarPath = `/documento-cancelacion-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoCancelacionIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
         * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoIncumplimiento: async (documentoIncumplimiento: Array<DocumentoIncumplimiento>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentoIncumplimiento' is not null or undefined
            assertParamExists('createDocumentoIncumplimiento', 'documentoIncumplimiento', documentoIncumplimiento)
            const localVarPath = `/documento-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo documento para el registro del representante
         * @param {number} id Identificador único
         * @param {DocumentoRepresentante} documentoRepresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoRepresentante: async (id: number, documentoRepresentante: DocumentoRepresentante, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocumentoRepresentante', 'id', id)
            // verify required parameter 'documentoRepresentante' is not null or undefined
            assertParamExists('createDocumentoRepresentante', 'documentoRepresentante', documentoRepresentante)
            const localVarPath = `/documento-representante/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoRepresentante, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo documento para el registro de sede
         * @param {number} id Identificador único
         * @param {DocumentoSede} documentoSede 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoSede: async (id: number, documentoSede: DocumentoSede, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDocumentoSede', 'id', id)
            // verify required parameter 'documentoSede' is not null or undefined
            assertParamExists('createDocumentoSede', 'documentoSede', documentoSede)
            const localVarPath = `/documento-sede/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentoSede, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo domicilio de un residencial
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomicilioResidencial: async (id: number, registroDomicilio: RegistroDomicilio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDomicilioResidencial', 'id', id)
            // verify required parameter 'registroDomicilio' is not null or undefined
            assertParamExists('createDomicilioResidencial', 'registroDomicilio', registroDomicilio)
            const localVarPath = `/domicilio-residencial/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registroDomicilio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedioContacto: async (idPersona: number, idRegistro: number, medioContacto: MedioContacto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createMedioContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createMedioContacto', 'idRegistro', idRegistro)
            // verify required parameter 'medioContacto' is not null or undefined
            assertParamExists('createMedioContacto', 'medioContacto', medioContacto)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medioContacto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediosContacto: async (idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createMediosContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('createMediosContacto', 'idRegistro', idRegistro)
            // verify required parameter 'medioContacto' is not null or undefined
            assertParamExists('createMediosContacto', 'medioContacto', medioContacto)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}/bulk`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medioContacto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear una nueva subsede
         * @param {number} idSede Identificador de la sede padre
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevaSubsede: async (idSede: number, nuevoRegistro: NuevoRegistro, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSede' is not null or undefined
            assertParamExists('createNuevaSubsede', 'idSede', idSede)
            // verify required parameter 'nuevoRegistro' is not null or undefined
            assertParamExists('createNuevaSubsede', 'nuevoRegistro', nuevoRegistro)
            const localVarPath = `/subsede/{idSede}`
                .replace(`{${"idSede"}}`, encodeURIComponent(String(idSede)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nuevoRegistro, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevoRegistro: async (nuevoRegistro: NuevoRegistro, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nuevoRegistro' is not null or undefined
            assertParamExists('createNuevoRegistro', 'nuevoRegistro', nuevoRegistro)
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nuevoRegistro, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nueva persona registro
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonaRegistro: async (id: number, persona: Persona, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPersonaRegistro', 'id', id)
            // verify required parameter 'persona' is not null or undefined
            assertParamExists('createPersonaRegistro', 'persona', persona)
            const localVarPath = `/persona-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persona, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {Plataforma} plataforma 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlataformas: async (plataforma: Plataforma, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plataforma' is not null or undefined
            assertParamExists('createPlataformas', 'plataforma', plataforma)
            const localVarPath = `/plataformas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plataforma, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un poder otrogado para una persona
         * @param {number} idPersona Identificador de la persona
         * @param {PoderOtorgado} poderOtorgado 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPoderOtorgado: async (idPersona: number, poderOtorgado: PoderOtorgado, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('createPoderOtorgado', 'idPersona', idPersona)
            // verify required parameter 'poderOtorgado' is not null or undefined
            assertParamExists('createPoderOtorgado', 'poderOtorgado', poderOtorgado)
            const localVarPath = `/poder-otorgado/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poderOtorgado, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroAnotaciones: async (anotacionesIncumplimiento: AnotacionesIncumplimiento, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anotacionesIncumplimiento' is not null or undefined
            assertParamExists('createRegistroAnotaciones', 'anotacionesIncumplimiento', anotacionesIncumplimiento)
            const localVarPath = `/anotaciones-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anotacionesIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro de cancelacion de incumplimiento
         * @param {number} id Identificador único
         * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroCancelacionIncumplimiento: async (id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createRegistroCancelacionIncumplimiento', 'id', id)
            // verify required parameter 'registroCancelacionIncumplimiento' is not null or undefined
            assertParamExists('createRegistroCancelacionIncumplimiento', 'registroCancelacionIncumplimiento', registroCancelacionIncumplimiento)
            const localVarPath = `/registro-cancelacion-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registroCancelacionIncumplimiento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo domicilio de un registro
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroDomicilio: async (id: number, registroDomicilio: RegistroDomicilio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createRegistroDomicilio', 'id', id)
            // verify required parameter 'registroDomicilio' is not null or undefined
            assertParamExists('createRegistroDomicilio', 'registroDomicilio', registroDomicilio)
            const localVarPath = `/domicilio-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registroDomicilio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo socio de un documento creación
         * @param {number} id Identificador único
         * @param {Socio} socio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSocio: async (id: number, socio: Socio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSocio', 'id', id)
            // verify required parameter 'socio' is not null or undefined
            assertParamExists('createSocio', 'socio', socio)
            const localVarPath = `/socio/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crear un nuevo registro
         * @param {Subsistema} subsistema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubsistemas: async (subsistema: Subsistema, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subsistema' is not null or undefined
            assertParamExists('createSubsistemas', 'subsistema', subsistema)
            const localVarPath = `/subsistemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subsistema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina una asignación de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsignacionRevisor: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteAsignacionRevisor', 'idRegistro', idRegistro)
            const localVarPath = `/registro/revisor/asignacion/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistro: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteRegistro', 'idRegistro', idRegistro)
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idRegistro !== undefined) {
                localVarQueryParameter['idRegistro'] = idRegistro;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistroSubsede: async (idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteRegistroSubsede', 'idRegistro', idRegistro)
            // verify required parameter 'esAdmin' is not null or undefined
            assertParamExists('deleteRegistroSubsede', 'esAdmin', esAdmin)
            // verify required parameter 'inlineObject2' is not null or undefined
            assertParamExists('deleteRegistroSubsede', 'inlineObject2', inlineObject2)
            const localVarPath = `/subsede`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idRegistro !== undefined) {
                localVarQueryParameter['idRegistro'] = idRegistro;
            }

            if (esAdmin !== undefined) {
                localVarQueryParameter['esAdmin'] = esAdmin;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un representante
         * @param {number} idRegistro Identificador único del registro
         * @param {number} idPersona Identificador de la persona
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRepresentante: async (idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('deleteRepresentante', 'idRegistro', idRegistro)
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('deleteRepresentante', 'idPersona', idPersona)
            const localVarPath = `/persona-registro/{idRegistro}/elimina-representante/{idPersona}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)))
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Elimina un socio de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSocio: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSocio', 'id', id)
            const localVarPath = `/socio/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviaRegistro: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enviaRegistro', 'id', id)
            const localVarPath = `/registro/envia/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtiene una persona física o moral por su número de RENIECYT
         * @param {string} numeroReniecyt numeroReniecyt
         * @param {boolean} [completo] Indica si obtendrá información completa de reniecyt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNumeroReniecyt: async (numeroReniecyt: string, completo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numeroReniecyt' is not null or undefined
            assertParamExists('findByNumeroReniecyt', 'numeroReniecyt', numeroReniecyt)
            const localVarPath = `/reniecyt/{numeroReniecyt}`
                .replace(`{${"numeroReniecyt"}}`, encodeURIComponent(String(numeroReniecyt)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (completo !== undefined) {
                localVarQueryParameter['completo'] = completo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioPersonaRegistro: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getComentarioPersonaRegistro', 'idPersona', idPersona)
            const localVarPath = `/persona-registro/comentario/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioTemporalRegistro: async (idRegistroEstatus: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistroEstatus' is not null or undefined
            assertParamExists('getComentarioTemporalRegistro', 'idRegistroEstatus', idRegistroEstatus)
            const localVarPath = `/registro/comentarioTemporales/{idRegistroEstatus}`
                .replace(`{${"idRegistroEstatus"}}`, encodeURIComponent(String(idRegistroEstatus)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentariosRegistro: async (idRegistro: number, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getComentariosRegistro', 'idRegistro', idRegistro)
            const localVarPath = `/registro/{idRegistro}/comentarios`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener la informacion de los datos de actualizacion de una sede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosActualizadosInstitucion: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getDatosActualizadosInstitucion', 'idRegistro', idRegistro)
            const localVarPath = `/registro/{idRegistro}/actualiza-datos-institucion`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener la informacion de los datos de eliminacion de una subsede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosEliminacionSubsede: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getDatosEliminacionSubsede', 'idRegistro', idRegistro)
            const localVarPath = `/subsede/datos-eliminacion/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosGenerales: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatosGenerales', 'id', id)
            const localVarPath = `/datos-generales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el documento de creacion
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoCreacion: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentoCreacion', 'id', id)
            const localVarPath = `/documento-creacion/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el documento del representante
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoRepresentante: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentoRepresentante', 'id', id)
            const localVarPath = `/documento-representante/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el documento de un registro de sede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoSede: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentoSede', 'id', id)
            const localVarPath = `/documento-sede/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentos: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumentos', 'id', id)
            const localVarPath = `/documentos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los documentos de anotaciones de incumplimiento
         * @param {number} idIncumplimiento ID del incumplimiento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosIncumplimiento: async (idIncumplimiento: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idIncumplimiento' is not null or undefined
            assertParamExists('getDocumentosIncumplimiento', 'idIncumplimiento', idIncumplimiento)
            const localVarPath = `/documento-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idIncumplimiento !== undefined) {
                localVarQueryParameter['idIncumplimiento'] = idIncumplimiento;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el domicilio de un residencial
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomicilioResidencial: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDomicilioResidencial', 'id', id)
            const localVarPath = `/domicilio-residencial/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el valor booleano en caso de tener o no un registro de persona física
         * @param {string} [cvu] cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRegistrofisica: async (cvu?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/existe-registro-fisica`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (cvu !== undefined) {
                localVarQueryParameter['cvu'] = cvu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el valor booleano en caso de existir o no un rfc
         * @param {string} rfc rfc del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRfc: async (rfc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rfc' is not null or undefined
            assertParamExists('getExisteRfc', 'rfc', rfc)
            const localVarPath = `/existe-rfc/{rfc}`
                .replace(`{${"rfc"}}`, encodeURIComponent(String(rfc)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitucionSnp: async (noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro/snp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (noDeRegistroQuery !== undefined) {
                localVarQueryParameter['noDeRegistroQuery'] = noDeRegistroQuery;
            }

            if (rfcQuery !== undefined) {
                localVarQueryParameter['rfcQuery'] = rfcQuery;
            }

            if (tipoSolicitud !== undefined) {
                localVarQueryParameter['tipoSolicitud'] = tipoSolicitud;
            }

            if (sector !== undefined) {
                localVarQueryParameter['sector'] = sector;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener la lista de estatus de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListaEstatus: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getListaEstatus', 'idRegistro', idRegistro)
            const localVarPath = `/registro/lista-estatus/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediosContacto: async (idPersona: number, idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getMediosContacto', 'idPersona', idPersona)
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getMediosContacto', 'idRegistro', idRegistro)
            const localVarPath = `/medios-contacto/{idPersona}/{idRegistro}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)))
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene una persona basada en su ID
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersona: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getPersona', 'idPersona', idPersona)
            const localVarPath = `/persona/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener a los representantes legales
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaRegistros: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonaRegistros', 'id', id)
            const localVarPath = `/persona-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de plataformas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlataformas: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/plataformas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Método utilizado para recuperar el poder otorgado a una persona
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoderOtorgado: async (idPersona: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPersona' is not null or undefined
            assertParamExists('getPoderOtorgado', 'idPersona', idPersona)
            const localVarPath = `/poder-otorgado/{idPersona}`
                .replace(`{${"idPersona"}}`, encodeURIComponent(String(idPersona)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroAnotacion: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistroAnotacion', 'id', id)
            const localVarPath = `/anotaciones-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener un registro de cancelación de incumplimiento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroCancelacionIncumplimiento: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistroCancelacionIncumplimiento', 'id', id)
            const localVarPath = `/registro-cancelacion-incumplimiento/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener el domicilio de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroDomicilio: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistroDomicilio', 'id', id)
            const localVarPath = `/domicilio-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de un CVU
         * @param {string} [cvu] cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroSolicitudes: async (cvu?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (cvu !== undefined) {
                localVarQueryParameter['cvu'] = cvu;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {string} [numeroOficio] Número de oficio.
         * @param {string} [numeroFolio] Número de folio.
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosAnotaciones: async (numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/anotaciones-incumplimiento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (numeroOficio !== undefined) {
                localVarQueryParameter['numeroOficio'] = numeroOficio;
            }

            if (numeroFolio !== undefined) {
                localVarQueryParameter['numeroFolio'] = numeroFolio;
            }

            if (cvuRepLegal !== undefined) {
                localVarQueryParameter['cvuRepLegal'] = cvuRepLegal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {number} [estatusRegistroQuery] Estatus del registro.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {string} [nombreRepLegal] nombre del representante legal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosRevisor: async (rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro/revisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (rfcQuery !== undefined) {
                localVarQueryParameter['rfcQuery'] = rfcQuery;
            }

            if (empresaInstitucionQuery !== undefined) {
                localVarQueryParameter['empresaInstitucionQuery'] = empresaInstitucionQuery;
            }

            if (noDeRegistroQuery !== undefined) {
                localVarQueryParameter['noDeRegistroQuery'] = noDeRegistroQuery;
            }

            if (estatusRegistroQuery !== undefined) {
                localVarQueryParameter['estatusRegistroQuery'] = estatusRegistroQuery;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (cvuRevisor !== undefined) {
                localVarQueryParameter['cvuRevisor'] = cvuRevisor;
            }

            if (misAsignaciones !== undefined) {
                localVarQueryParameter['misAsignaciones'] = misAsignaciones;
            }

            if (esAdmin !== undefined) {
                localVarQueryParameter['esAdmin'] = esAdmin;
            }

            if (cvuRepLegal !== undefined) {
                localVarQueryParameter['cvuRepLegal'] = cvuRepLegal;
            }

            if (nombreRepLegal !== undefined) {
                localVarQueryParameter['nombreRepLegal'] = nombreRepLegal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exportar pdf registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReporteRegistro: async (idRegistro: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('getReporteRegistro', 'idRegistro', idRegistro)
            const localVarPath = `/registro/pdf/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtiene los reportes de PM
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportes: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportes', 'id', id)
            const localVarPath = `/reportes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los socios de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocios: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSocios', 'id', id)
            const localVarPath = `/socio/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todas las subsedes de un registro
         * @param {number} idSede Identificador de la sede padre
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedes: async (idSede: number, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSede' is not null or undefined
            assertParamExists('getSubsedes', 'idSede', idSede)
            const localVarPath = `/subsede/{idSede}`
                .replace(`{${"idSede"}}`, encodeURIComponent(String(idSede)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todas las subsedes asociadas a un cvu
         * @param {string} cvu Cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesByCvu: async (cvu: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            assertParamExists('getSubsedesByCvu', 'cvu', cvu)
            const localVarPath = `/subsede`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (cvu !== undefined) {
                localVarQueryParameter['cvu'] = cvu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todas las subsedes
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [noRegistro] No de Registro de la subsede
         * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
         * @param {number} [estatus] Estatus de la subsede
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesRevisor: async (page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subsede/revisor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (cvuRevisor !== undefined) {
                localVarQueryParameter['cvuRevisor'] = cvuRevisor;
            }

            if (misAsignaciones !== undefined) {
                localVarQueryParameter['misAsignaciones'] = misAsignaciones;
            }

            if (esAdmin !== undefined) {
                localVarQueryParameter['esAdmin'] = esAdmin;
            }

            if (noRegistro !== undefined) {
                localVarQueryParameter['noRegistro'] = noRegistro;
            }

            if (empresaInstitucion !== undefined) {
                localVarQueryParameter['empresaInstitucion'] = empresaInstitucion;
            }

            if (estatus !== undefined) {
                localVarQueryParameter['estatus'] = estatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los registros de subsistemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsistemas: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subsistemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener todos los tipos de usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipoUsuario: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tipo-usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getjobStatus', 'id', id)
            const localVarPath = `/reniecyt-job/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarComentarioTemporal: async (comentarioRegistroEstatus: ComentarioRegistroEstatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comentarioRegistroEstatus' is not null or undefined
            assertParamExists('guardarComentarioTemporal', 'comentarioRegistroEstatus', comentarioRegistroEstatus)
            const localVarPath = `/registro/comentarioTemporales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comentarioRegistroEstatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza la informacion de una persona
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersona: async (id: number, persona: Persona, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePersona', 'id', id)
            // verify required parameter 'persona' is not null or undefined
            assertParamExists('updatePersona', 'persona', persona)
            const localVarPath = `/persona-registro/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persona, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actualiza un registro
         * @param {number} idRegistro Id del registro
         * @param {ActualizaRegistro} actualizaRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegistro: async (idRegistro: number, actualizaRegistro: ActualizaRegistro, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('updateRegistro', 'idRegistro', idRegistro)
            // verify required parameter 'actualizaRegistro' is not null or undefined
            assertParamExists('updateRegistro', 'actualizaRegistro', actualizaRegistro)
            const localVarPath = `/registro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idRegistro !== undefined) {
                localVarQueryParameter['idRegistro'] = idRegistro;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actualizaRegistro, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDatosGenerales: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDatosGenerales', 'id', id)
            const localVarPath = `/datos-generales/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoCreacion: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDocumentoCreacion', 'id', id)
            const localVarPath = `/documento-creacion/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoRepresentante: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDocumentoRepresentante', 'id', id)
            const localVarPath = `/documento-representante/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoSede: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDocumentoSede', 'id', id)
            const localVarPath = `/documento-sede/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioRegistro: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDomicilioRegistro', 'id', id)
            const localVarPath = `/domicilio-registro/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioResidencial: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaDomicilioResidencial', 'id', id)
            const localVarPath = `/domicilio-residencial/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaPoderOtorgado: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaPoderOtorgado', 'id', id)
            const localVarPath = `/poder-otorgado/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtener una lista de la validación de cada subsede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaSubsedes: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validaSubsedes', 'id', id)
            const localVarPath = `/subsede/{id}/valida`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReniecytApi - functional programming interface
 * @export
 */
export const ReniecytApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReniecytApiAxiosParamCreator(configuration)
    return {
        /**
         * Actualiza los datos de institucion de una sede dado su id.
         * @param {number} idRegistro Identificador único del registro
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaDatosInstitucion(idRegistro: number, inlineObject: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaDatosInstitucion(idRegistro, inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza el estado de un registro en base al ID del registro.
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaEstatusCaptura(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaEstatusCaptura(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
         * @param {number} idRegistro Identificador único del registro
         * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
         * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaRegistroObservaciones(idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaRegistroObservaciones(idRegistro, estado, comentarioRechazoSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaSector(idRegistro: number, sector: Sector, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaSector(idRegistro, sector, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Busca registros por número de RENIECYT, RFC o razón social
         * @param {string} [numeroRegistro] Número de RENIECYT del registro
         * @param {string} [rfc] RFC del registro
         * @param {string} [nombreInstitucion] Razón social del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buscarInstitucionReniecyt(numeroRegistro?: string, rfc?: string, nombreInstitucion?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistroReniecyt>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buscarInstitucionReniecyt(numeroRegistro, rfc, nombreInstitucion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Asignar un registro a un revisor
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAsignacionRevisor(idRegistro: number, cvuRevisor?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAsignacionRevisor(idRegistro, cvuRevisor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo documento de creación
         * @param {number} id Identificador único
         * @param {DocumentoCreacion} documentoCreacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocuementoCreacion(id: number, documentoCreacion: DocumentoCreacion, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocuementoCreacion(id, documentoCreacion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
         * @param {number} id Identificador único
         * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoCancelacionIncumplimiento(id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoCancelacionIncumplimiento(id, documentoCancelacionIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
         * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoIncumplimiento(documentoIncumplimiento: Array<DocumentoIncumplimiento>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoIncumplimiento(documentoIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo documento para el registro del representante
         * @param {number} id Identificador único
         * @param {DocumentoRepresentante} documentoRepresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoRepresentante(id: number, documentoRepresentante: DocumentoRepresentante, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoRepresentante(id, documentoRepresentante, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo documento para el registro de sede
         * @param {number} id Identificador único
         * @param {DocumentoSede} documentoSede 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentoSede(id: number, documentoSede: DocumentoSede, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentoSede(id, documentoSede, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo domicilio de un residencial
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDomicilioResidencial(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDomicilioResidencial(id, registroDomicilio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedioContacto(idPersona, idRegistro, medioContacto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMediosContacto(idPersona, idRegistro, medioContacto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear una nueva subsede
         * @param {number} idSede Identificador de la sede padre
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNuevaSubsede(idSede: number, nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNuevaSubsede(idSede, nuevoRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNuevoRegistro(nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNuevoRegistro(nuevoRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nueva persona registro
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonaRegistro(id: number, persona: Persona, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonaRegistro(id, persona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {Plataforma} plataforma 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlataformas(plataforma: Plataforma, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlataformas(plataforma, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un poder otrogado para una persona
         * @param {number} idPersona Identificador de la persona
         * @param {PoderOtorgado} poderOtorgado 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPoderOtorgado(idPersona: number, poderOtorgado: PoderOtorgado, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPoderOtorgado(idPersona, poderOtorgado, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistroAnotaciones(anotacionesIncumplimiento: AnotacionesIncumplimiento, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistroAnotaciones(anotacionesIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro de cancelacion de incumplimiento
         * @param {number} id Identificador único
         * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistroCancelacionIncumplimiento(id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistroCancelacionIncumplimiento(id, registroCancelacionIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo domicilio de un registro
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistroDomicilio(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistroDomicilio(id, registroDomicilio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo socio de un documento creación
         * @param {number} id Identificador único
         * @param {Socio} socio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSocio(id: number, socio: Socio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSocio(id, socio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Crear un nuevo registro
         * @param {Subsistema} subsistema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubsistemas(subsistema: Subsistema, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubsistemas(subsistema, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina una asignación de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAsignacionRevisor(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsignacionRevisor(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegistro(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegistro(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegistroSubsede(idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegistroSubsede(idRegistro, esAdmin, inlineObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un representante
         * @param {number} idRegistro Identificador único del registro
         * @param {number} idPersona Identificador de la persona
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRepresentante(idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRepresentante(idRegistro, idPersona, inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Elimina un socio de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSocio(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSocio(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviaRegistro(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviaRegistro(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtiene una persona física o moral por su número de RENIECYT
         * @param {string} numeroReniecyt numeroReniecyt
         * @param {boolean} [completo] Indica si obtendrá información completa de reniecyt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByNumeroReniecyt(numeroReniecyt: string, completo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroReniecyt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByNumeroReniecyt(numeroReniecyt, completo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentarioPersonaRegistro(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComentarioPersonaRegistro>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentarioPersonaRegistro(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentarioTemporalRegistro(idRegistroEstatus: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComentarioRegistroEstatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentarioTemporalRegistro(idRegistroEstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComentariosRegistro(idRegistro: number, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComentarioRegistroEstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComentariosRegistro(idRegistro, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener la informacion de los datos de actualizacion de una sede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosActualizadosInstitucion(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatosSedeHistorico>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosActualizadosInstitucion(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener la informacion de los datos de eliminacion de una subsede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosEliminacionSubsede(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosEliminacionSubsede>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosEliminacionSubsede(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosGenerales(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultaRegistro>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosGenerales(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el documento de creacion
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentoCreacion(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoCreacion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentoCreacion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el documento del representante
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentoRepresentante(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoRepresentante>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentoRepresentante(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el documento de un registro de sede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentoSede(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoSede>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentoSede(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentos(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListaDocumentos>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentos(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los documentos de anotaciones de incumplimiento
         * @param {number} idIncumplimiento ID del incumplimiento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentosIncumplimiento(idIncumplimiento: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentoIncumplimiento>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentosIncumplimiento(idIncumplimiento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el domicilio de un residencial
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDomicilioResidencial(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroDomicilio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDomicilioResidencial(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el valor booleano en caso de tener o no un registro de persona física
         * @param {string} [cvu] cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExisteRegistrofisica(cvu?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExisteRegistrofisica(cvu, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el valor booleano en caso de existir o no un rfc
         * @param {string} rfc rfc del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExisteRfc(rfc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExisteRfc(rfc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InstitucionSnp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener la lista de estatus de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListaEstatus(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistroEstatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListaEstatus(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediosContacto(idPersona: number, idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MedioContacto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediosContacto(idPersona, idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene una persona basada en su ID
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersona(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Persona>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersona(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener a los representantes legales
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonaRegistros(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Persona>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonaRegistros(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de plataformas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlataformas(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Plataforma>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlataformas(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Método utilizado para recuperar el poder otorgado a una persona
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPoderOtorgado(idPersona: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoderOtorgado>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPoderOtorgado(idPersona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroAnotacion(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnotacionesIncumplimiento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroAnotacion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener un registro de cancelación de incumplimiento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroCancelacionIncumplimiento(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroCancelacionIncumplimiento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroCancelacionIncumplimiento(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener el domicilio de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroDomicilio(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistroDomicilio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroDomicilio(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de un CVU
         * @param {string} [cvu] cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistroSolicitudes(cvu?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistroSolicitudes(cvu, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {string} [numeroOficio] Número de oficio.
         * @param {string} [numeroFolio] Número de folio.
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrosAnotaciones(numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnotacionesIncumplimiento>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrosAnotaciones(numeroOficio, numeroFolio, cvuRepLegal, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {number} [estatusRegistroQuery] Estatus del registro.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {string} [nombreRepLegal] nombre del representante legal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrosRevisor(rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrosRevisor(rfcQuery, empresaInstitucionQuery, noDeRegistroQuery, estatusRegistroQuery, page, size, cvuRevisor, misAsignaciones, esAdmin, cvuRepLegal, nombreRepLegal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Exportar pdf registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReporteRegistro(idRegistro: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoExport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReporteRegistro(idRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtiene los reportes de PM
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportes(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportes(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los socios de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocios(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Socio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocios(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todas las subsedes de un registro
         * @param {number} idSede Identificador de la sede padre
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsedes(idSede: number, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsedes(idSede, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todas las subsedes asociadas a un cvu
         * @param {string} cvu Cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsedesByCvu(cvu: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsedesByCvu(cvu, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todas las subsedes
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [noRegistro] No de Registro de la subsede
         * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
         * @param {number} [estatus] Estatus de la subsede
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsedesRevisor(page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsedesRevisor(page, size, cvuRevisor, misAsignaciones, esAdmin, noRegistro, empresaInstitucion, estatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los registros de subsistemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubsistemas(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Subsistema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubsistemas(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener todos los tipos de usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTipoUsuario(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TipoUsuario>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTipoUsuario(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getjobStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getjobStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guardarComentarioTemporal(comentarioRegistroEstatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza la informacion de una persona
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersona(id: number, persona: Persona, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersona(id, persona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Actualiza un registro
         * @param {number} idRegistro Id del registro
         * @param {ActualizaRegistro} actualizaRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRegistro(idRegistro: number, actualizaRegistro: ActualizaRegistro, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRegistro(idRegistro, actualizaRegistro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDatosGenerales(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDatosGenerales(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentoCreacion(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDocumentoCreacion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentoRepresentante(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDocumentoRepresentante(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDocumentoSede(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDocumentoSede(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDomicilioRegistro(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDomicilioRegistro(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaDomicilioResidencial(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaDomicilioResidencial(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaPoderOtorgado(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaPoderOtorgado(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtener una lista de la validación de cada subsede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaSubsedes(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidateSubsede>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validaSubsedes(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReniecytApi - factory interface
 * @export
 */
export const ReniecytApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReniecytApiFp(configuration)
    return {
        /**
         * Actualiza los datos de institucion de una sede dado su id.
         * @param {number} idRegistro Identificador único del registro
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaDatosInstitucion(idRegistro: number, inlineObject: InlineObject, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaDatosInstitucion(idRegistro, inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza el estado de un registro en base al ID del registro.
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaEstatusCaptura(idRegistro: number, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaEstatusCaptura(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
         * @param {number} idRegistro Identificador único del registro
         * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
         * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaRegistroObservaciones(idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaRegistroObservaciones(idRegistro, estado, comentarioRechazoSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaSector(idRegistro: number, sector: Sector, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaSector(idRegistro, sector, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Busca registros por número de RENIECYT, RFC o razón social
         * @param {string} [numeroRegistro] Número de RENIECYT del registro
         * @param {string} [rfc] RFC del registro
         * @param {string} [nombreInstitucion] Razón social del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buscarInstitucionReniecyt(numeroRegistro?: string, rfc?: string, nombreInstitucion?: string, options?: any): AxiosPromise<Array<RegistroReniecyt>> {
            return localVarFp.buscarInstitucionReniecyt(numeroRegistro, rfc, nombreInstitucion, options).then((request) => request(axios, basePath));
        },
        /**
         * Asignar un registro a un revisor
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAsignacionRevisor(idRegistro: number, cvuRevisor?: number, options?: any): AxiosPromise<void> {
            return localVarFp.createAsignacionRevisor(idRegistro, cvuRevisor, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo documento de creación
         * @param {number} id Identificador único
         * @param {DocumentoCreacion} documentoCreacion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocuementoCreacion(id: number, documentoCreacion: DocumentoCreacion, options?: any): AxiosPromise<void> {
            return localVarFp.createDocuementoCreacion(id, documentoCreacion, options).then((request) => request(axios, basePath));
        },
        /**
         * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
         * @param {number} id Identificador único
         * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoCancelacionIncumplimiento(id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoCancelacionIncumplimiento(id, documentoCancelacionIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
         * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoIncumplimiento(documentoIncumplimiento: Array<DocumentoIncumplimiento>, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoIncumplimiento(documentoIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo documento para el registro del representante
         * @param {number} id Identificador único
         * @param {DocumentoRepresentante} documentoRepresentante 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoRepresentante(id: number, documentoRepresentante: DocumentoRepresentante, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoRepresentante(id, documentoRepresentante, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo documento para el registro de sede
         * @param {number} id Identificador único
         * @param {DocumentoSede} documentoSede 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentoSede(id: number, documentoSede: DocumentoSede, options?: any): AxiosPromise<void> {
            return localVarFp.createDocumentoSede(id, documentoSede, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo domicilio de un residencial
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomicilioResidencial(id: number, registroDomicilio: RegistroDomicilio, options?: any): AxiosPromise<void> {
            return localVarFp.createDomicilioResidencial(id, registroDomicilio, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo medio de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {MedioContacto} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: any): AxiosPromise<void> {
            return localVarFp.createMedioContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {Array<MedioContacto>} medioContacto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: any): AxiosPromise<void> {
            return localVarFp.createMediosContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear una nueva subsede
         * @param {number} idSede Identificador de la sede padre
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevaSubsede(idSede: number, nuevoRegistro: NuevoRegistro, options?: any): AxiosPromise<void> {
            return localVarFp.createNuevaSubsede(idSede, nuevoRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {NuevoRegistro} nuevoRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNuevoRegistro(nuevoRegistro: NuevoRegistro, options?: any): AxiosPromise<void> {
            return localVarFp.createNuevoRegistro(nuevoRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nueva persona registro
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonaRegistro(id: number, persona: Persona, options?: any): AxiosPromise<void> {
            return localVarFp.createPersonaRegistro(id, persona, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {Plataforma} plataforma 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlataformas(plataforma: Plataforma, options?: any): AxiosPromise<void> {
            return localVarFp.createPlataformas(plataforma, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un poder otrogado para una persona
         * @param {number} idPersona Identificador de la persona
         * @param {PoderOtorgado} poderOtorgado 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPoderOtorgado(idPersona: number, poderOtorgado: PoderOtorgado, options?: any): AxiosPromise<void> {
            return localVarFp.createPoderOtorgado(idPersona, poderOtorgado, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroAnotaciones(anotacionesIncumplimiento: AnotacionesIncumplimiento, options?: any): AxiosPromise<void> {
            return localVarFp.createRegistroAnotaciones(anotacionesIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro de cancelacion de incumplimiento
         * @param {number} id Identificador único
         * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroCancelacionIncumplimiento(id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options?: any): AxiosPromise<void> {
            return localVarFp.createRegistroCancelacionIncumplimiento(id, registroCancelacionIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo domicilio de un registro
         * @param {number} id Identificador único
         * @param {RegistroDomicilio} registroDomicilio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistroDomicilio(id: number, registroDomicilio: RegistroDomicilio, options?: any): AxiosPromise<void> {
            return localVarFp.createRegistroDomicilio(id, registroDomicilio, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo socio de un documento creación
         * @param {number} id Identificador único
         * @param {Socio} socio 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSocio(id: number, socio: Socio, options?: any): AxiosPromise<void> {
            return localVarFp.createSocio(id, socio, options).then((request) => request(axios, basePath));
        },
        /**
         * Crear un nuevo registro
         * @param {Subsistema} subsistema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubsistemas(subsistema: Subsistema, options?: any): AxiosPromise<void> {
            return localVarFp.createSubsistemas(subsistema, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina una asignación de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsignacionRevisor(idRegistro: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAsignacionRevisor(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistro(idRegistro: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRegistro(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un registro
         * @param {number} idRegistro Id del registro
         * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistroSubsede(idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRegistroSubsede(idRegistro, esAdmin, inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un representante
         * @param {number} idRegistro Identificador único del registro
         * @param {number} idPersona Identificador de la persona
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRepresentante(idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRepresentante(idRegistro, idPersona, inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * Elimina un socio de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSocio(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSocio(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviaRegistro(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.enviaRegistro(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una persona física o moral por su número de RENIECYT
         * @param {string} numeroReniecyt numeroReniecyt
         * @param {boolean} [completo] Indica si obtendrá información completa de reniecyt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNumeroReniecyt(numeroReniecyt: string, completo?: boolean, options?: any): AxiosPromise<RegistroReniecyt> {
            return localVarFp.findByNumeroReniecyt(numeroReniecyt, completo, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene el comentario de una persona eliminada
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioPersonaRegistro(idPersona: number, options?: any): AxiosPromise<ComentarioPersonaRegistro> {
            return localVarFp.getComentarioPersonaRegistro(idPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistroEstatus Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentarioTemporalRegistro(idRegistroEstatus: number, options?: any): AxiosPromise<ComentarioRegistroEstatus> {
            return localVarFp.getComentarioTemporalRegistro(idRegistroEstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los comentarios asociados a un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComentariosRegistro(idRegistro: number, page?: number, size?: number, options?: any): AxiosPromise<Array<ComentarioRegistroEstatus>> {
            return localVarFp.getComentariosRegistro(idRegistro, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener la informacion de los datos de actualizacion de una sede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosActualizadosInstitucion(idRegistro: number, options?: any): AxiosPromise<Array<DatosSedeHistorico>> {
            return localVarFp.getDatosActualizadosInstitucion(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener la informacion de los datos de eliminacion de una subsede
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosEliminacionSubsede(idRegistro: number, options?: any): AxiosPromise<DatosEliminacionSubsede> {
            return localVarFp.getDatosEliminacionSubsede(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosGenerales(id: number, options?: any): AxiosPromise<ConsultaRegistro> {
            return localVarFp.getDatosGenerales(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el documento de creacion
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoCreacion(id: number, options?: any): AxiosPromise<DocumentoCreacion> {
            return localVarFp.getDocumentoCreacion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el documento del representante
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoRepresentante(id: number, options?: any): AxiosPromise<DocumentoRepresentante> {
            return localVarFp.getDocumentoRepresentante(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el documento de un registro de sede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentoSede(id: number, options?: any): AxiosPromise<DocumentoSede> {
            return localVarFp.getDocumentoSede(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentos(id: number, options?: any): AxiosPromise<ListaDocumentos> {
            return localVarFp.getDocumentos(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los documentos de anotaciones de incumplimiento
         * @param {number} idIncumplimiento ID del incumplimiento
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentosIncumplimiento(idIncumplimiento: number, options?: any): AxiosPromise<Array<DocumentoIncumplimiento>> {
            return localVarFp.getDocumentosIncumplimiento(idIncumplimiento, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el domicilio de un residencial
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomicilioResidencial(id: number, options?: any): AxiosPromise<RegistroDomicilio> {
            return localVarFp.getDomicilioResidencial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el valor booleano en caso de tener o no un registro de persona física
         * @param {string} [cvu] cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRegistrofisica(cvu?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.getExisteRegistrofisica(cvu, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el valor booleano en caso de existir o no un rfc
         * @param {string} rfc rfc del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExisteRfc(rfc: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.getExisteRfc(rfc, options).then((request) => request(axios, basePath));
        },
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<InstitucionSnp>> {
            return localVarFp.getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener la lista de estatus de un registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListaEstatus(idRegistro: number, options?: any): AxiosPromise<Array<RegistroEstatus>> {
            return localVarFp.getListaEstatus(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los medios de contacto
         * @param {number} idPersona ID de la persona
         * @param {number} idRegistro ID del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediosContacto(idPersona: number, idRegistro: number, options?: any): AxiosPromise<Array<MedioContacto>> {
            return localVarFp.getMediosContacto(idPersona, idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene una persona basada en su ID
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersona(idPersona: number, options?: any): AxiosPromise<Persona> {
            return localVarFp.getPersona(idPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener a los representantes legales
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonaRegistros(id: number, options?: any): AxiosPromise<Array<Persona>> {
            return localVarFp.getPersonaRegistros(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de plataformas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlataformas(options?: any): AxiosPromise<Array<Plataforma>> {
            return localVarFp.getPlataformas(options).then((request) => request(axios, basePath));
        },
        /**
         * Método utilizado para recuperar el poder otorgado a una persona
         * @param {number} idPersona Identificador de la persona
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPoderOtorgado(idPersona: number, options?: any): AxiosPromise<PoderOtorgado> {
            return localVarFp.getPoderOtorgado(idPersona, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroAnotacion(id: number, options?: any): AxiosPromise<AnotacionesIncumplimiento> {
            return localVarFp.getRegistroAnotacion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener un registro de cancelación de incumplimiento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroCancelacionIncumplimiento(id: number, options?: any): AxiosPromise<RegistroCancelacionIncumplimiento> {
            return localVarFp.getRegistroCancelacionIncumplimiento(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener el domicilio de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroDomicilio(id: number, options?: any): AxiosPromise<RegistroDomicilio> {
            return localVarFp.getRegistroDomicilio(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de un CVU
         * @param {string} [cvu] cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistroSolicitudes(cvu?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getRegistroSolicitudes(cvu, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de anotaciones de incumplimiento
         * @param {string} [numeroOficio] Número de oficio.
         * @param {string} [numeroFolio] Número de folio.
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosAnotaciones(numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<AnotacionesIncumplimiento>> {
            return localVarFp.getRegistrosAnotaciones(numeroOficio, numeroFolio, cvuRepLegal, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {number} [estatusRegistroQuery] Estatus del registro.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [cvuRepLegal] cvu del representante legal
         * @param {string} [nombreRepLegal] nombre del representante legal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrosRevisor(rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getRegistrosRevisor(rfcQuery, empresaInstitucionQuery, noDeRegistroQuery, estatusRegistroQuery, page, size, cvuRevisor, misAsignaciones, esAdmin, cvuRepLegal, nombreRepLegal, options).then((request) => request(axios, basePath));
        },
        /**
         * Exportar pdf registro
         * @param {number} idRegistro Identificador único del registro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReporteRegistro(idRegistro: number, options?: any): AxiosPromise<DocumentoExport> {
            return localVarFp.getReporteRegistro(idRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtiene los reportes de PM
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportes(id: number, options?: any): AxiosPromise<any> {
            return localVarFp.getReportes(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los socios de un documento creación
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocios(id: number, options?: any): AxiosPromise<Array<Socio>> {
            return localVarFp.getSocios(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todas las subsedes de un registro
         * @param {number} idSede Identificador de la sede padre
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedes(idSede: number, page?: number, size?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getSubsedes(idSede, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todas las subsedes asociadas a un cvu
         * @param {string} cvu Cvu del usuario
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesByCvu(cvu: string, page?: number, size?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getSubsedesByCvu(cvu, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todas las subsedes
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {number} [cvuRevisor] Cvu del revisor
         * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
         * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
         * @param {string} [noRegistro] No de Registro de la subsede
         * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
         * @param {number} [estatus] Estatus de la subsede
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsedesRevisor(page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getSubsedesRevisor(page, size, cvuRevisor, misAsignaciones, esAdmin, noRegistro, empresaInstitucion, estatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los registros de subsistemas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubsistemas(options?: any): AxiosPromise<Array<Subsistema>> {
            return localVarFp.getSubsistemas(options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener todos los tipos de usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipoUsuario(options?: any): AxiosPromise<Array<TipoUsuario>> {
            return localVarFp.getTipoUsuario(options).then((request) => request(axios, basePath));
        },
        /**
         * Recupera el estado del job de jobrunr
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getjobStatus(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getjobStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Guarda el comentario temporal
         * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: any): AxiosPromise<void> {
            return localVarFp.guardarComentarioTemporal(comentarioRegistroEstatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza la informacion de una persona
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersona(id: number, persona: Persona, options?: any): AxiosPromise<void> {
            return localVarFp.updatePersona(id, persona, options).then((request) => request(axios, basePath));
        },
        /**
         * Actualiza un registro
         * @param {number} idRegistro Id del registro
         * @param {ActualizaRegistro} actualizaRegistro 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegistro(idRegistro: number, actualizaRegistro: ActualizaRegistro, options?: any): AxiosPromise<void> {
            return localVarFp.updateRegistro(idRegistro, actualizaRegistro, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDatosGenerales(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDatosGenerales(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoCreacion(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDocumentoCreacion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoRepresentante(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDocumentoRepresentante(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDocumentoSede(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDocumentoSede(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioRegistro(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDomicilioRegistro(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaDomicilioResidencial(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaDomicilioResidencial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener los datos generales de un registro
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaPoderOtorgado(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.validaPoderOtorgado(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtener una lista de la validación de cada subsede
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaSubsedes(id: number, options?: any): AxiosPromise<Array<ValidateSubsede>> {
            return localVarFp.validaSubsedes(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReniecytApi - object-oriented interface
 * @export
 * @class ReniecytApi
 * @extends {BaseAPI}
 */
export class ReniecytApi extends BaseAPI {
    /**
     * Actualiza los datos de institucion de una sede dado su id.
     * @param {number} idRegistro Identificador único del registro
     * @param {InlineObject} inlineObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public actualizaDatosInstitucion(idRegistro: number, inlineObject: InlineObject, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).actualizaDatosInstitucion(idRegistro, inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza el estado de un registro en base al ID del registro.
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public actualizaEstatusCaptura(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).actualizaEstatusCaptura(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza el estado del registro a aceptado o rechazado. Incluye un comentario si es rechazado.
     * @param {number} idRegistro Identificador único del registro
     * @param {'ACEPTADO' | 'RECHAZADO'} estado Indica si el registro es aceptado o rechazado (\&#39;aceptado\&#39;, \&#39;rechazado\&#39;)
     * @param {ComentarioRechazoSolicitud} [comentarioRechazoSolicitud] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public actualizaRegistroObservaciones(idRegistro: number, estado: 'ACEPTADO' | 'RECHAZADO', comentarioRechazoSolicitud?: ComentarioRechazoSolicitud, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).actualizaRegistroObservaciones(idRegistro, estado, comentarioRechazoSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza La informacion que provenga del objeto sector.
     * @param {number} idRegistro Identificador único del registro
     * @param {Sector} sector 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public actualizaSector(idRegistro: number, sector: Sector, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).actualizaSector(idRegistro, sector, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Busca registros por número de RENIECYT, RFC o razón social
     * @param {string} [numeroRegistro] Número de RENIECYT del registro
     * @param {string} [rfc] RFC del registro
     * @param {string} [nombreInstitucion] Razón social del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public buscarInstitucionReniecyt(numeroRegistro?: string, rfc?: string, nombreInstitucion?: string, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).buscarInstitucionReniecyt(numeroRegistro, rfc, nombreInstitucion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asignar un registro a un revisor
     * @param {number} idRegistro Identificador único del registro
     * @param {number} [cvuRevisor] Cvu del revisor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createAsignacionRevisor(idRegistro: number, cvuRevisor?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createAsignacionRevisor(idRegistro, cvuRevisor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo documento de creación
     * @param {number} id Identificador único
     * @param {DocumentoCreacion} documentoCreacion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createDocuementoCreacion(id: number, documentoCreacion: DocumentoCreacion, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createDocuementoCreacion(id, documentoCreacion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recibe un array de documentos de cancelación y los asocia al registro con el ID proporcionado.
     * @param {number} id Identificador único
     * @param {Array<DocumentoCancelacionIncumplimiento>} documentoCancelacionIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createDocumentoCancelacionIncumplimiento(id: number, documentoCancelacionIncumplimiento: Array<DocumentoCancelacionIncumplimiento>, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createDocumentoCancelacionIncumplimiento(id, documentoCancelacionIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recibe un array de documentos de anotación de incumplimiento y los asocia al registro con el ID proporcionado.
     * @param {Array<DocumentoIncumplimiento>} documentoIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createDocumentoIncumplimiento(documentoIncumplimiento: Array<DocumentoIncumplimiento>, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createDocumentoIncumplimiento(documentoIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo documento para el registro del representante
     * @param {number} id Identificador único
     * @param {DocumentoRepresentante} documentoRepresentante 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createDocumentoRepresentante(id: number, documentoRepresentante: DocumentoRepresentante, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createDocumentoRepresentante(id, documentoRepresentante, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo documento para el registro de sede
     * @param {number} id Identificador único
     * @param {DocumentoSede} documentoSede 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createDocumentoSede(id: number, documentoSede: DocumentoSede, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createDocumentoSede(id, documentoSede, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo domicilio de un residencial
     * @param {number} id Identificador único
     * @param {RegistroDomicilio} registroDomicilio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createDomicilioResidencial(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createDomicilioResidencial(id, registroDomicilio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo medio de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {MedioContacto} medioContacto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createMedioContacto(idPersona: number, idRegistro: number, medioContacto: MedioContacto, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createMedioContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear múltiples medios de contacto y reemplaza la lista anterior de medios de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {Array<MedioContacto>} medioContacto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createMediosContacto(idPersona: number, idRegistro: number, medioContacto: Array<MedioContacto>, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createMediosContacto(idPersona, idRegistro, medioContacto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear una nueva subsede
     * @param {number} idSede Identificador de la sede padre
     * @param {NuevoRegistro} nuevoRegistro 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createNuevaSubsede(idSede: number, nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createNuevaSubsede(idSede, nuevoRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {NuevoRegistro} nuevoRegistro 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createNuevoRegistro(nuevoRegistro: NuevoRegistro, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createNuevoRegistro(nuevoRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nueva persona registro
     * @param {number} id Identificador único
     * @param {Persona} persona 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createPersonaRegistro(id: number, persona: Persona, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createPersonaRegistro(id, persona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {Plataforma} plataforma 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createPlataformas(plataforma: Plataforma, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createPlataformas(plataforma, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un poder otrogado para una persona
     * @param {number} idPersona Identificador de la persona
     * @param {PoderOtorgado} poderOtorgado 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createPoderOtorgado(idPersona: number, poderOtorgado: PoderOtorgado, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createPoderOtorgado(idPersona, poderOtorgado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {AnotacionesIncumplimiento} anotacionesIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createRegistroAnotaciones(anotacionesIncumplimiento: AnotacionesIncumplimiento, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createRegistroAnotaciones(anotacionesIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro de cancelacion de incumplimiento
     * @param {number} id Identificador único
     * @param {RegistroCancelacionIncumplimiento} registroCancelacionIncumplimiento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createRegistroCancelacionIncumplimiento(id: number, registroCancelacionIncumplimiento: RegistroCancelacionIncumplimiento, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createRegistroCancelacionIncumplimiento(id, registroCancelacionIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo domicilio de un registro
     * @param {number} id Identificador único
     * @param {RegistroDomicilio} registroDomicilio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createRegistroDomicilio(id: number, registroDomicilio: RegistroDomicilio, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createRegistroDomicilio(id, registroDomicilio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo socio de un documento creación
     * @param {number} id Identificador único
     * @param {Socio} socio 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createSocio(id: number, socio: Socio, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createSocio(id, socio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crear un nuevo registro
     * @param {Subsistema} subsistema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public createSubsistemas(subsistema: Subsistema, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).createSubsistemas(subsistema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina una asignación de un registro
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public deleteAsignacionRevisor(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).deleteAsignacionRevisor(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un registro
     * @param {number} idRegistro Id del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public deleteRegistro(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).deleteRegistro(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un registro
     * @param {number} idRegistro Id del registro
     * @param {boolean} esAdmin Bandera para saber si el usuario es administrador
     * @param {InlineObject2} inlineObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public deleteRegistroSubsede(idRegistro: number, esAdmin: boolean, inlineObject2: InlineObject2, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).deleteRegistroSubsede(idRegistro, esAdmin, inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un representante
     * @param {number} idRegistro Identificador único del registro
     * @param {number} idPersona Identificador de la persona
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public deleteRepresentante(idRegistro: number, idPersona: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).deleteRepresentante(idRegistro, idPersona, inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Elimina un socio de un documento creación
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public deleteSocio(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).deleteSocio(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public enviaRegistro(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).enviaRegistro(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una persona física o moral por su número de RENIECYT
     * @param {string} numeroReniecyt numeroReniecyt
     * @param {boolean} [completo] Indica si obtendrá información completa de reniecyt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public findByNumeroReniecyt(numeroReniecyt: string, completo?: boolean, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).findByNumeroReniecyt(numeroReniecyt, completo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene el comentario de una persona eliminada
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getComentarioPersonaRegistro(idPersona: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getComentarioPersonaRegistro(idPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los comentarios asociados a un registro
     * @param {number} idRegistroEstatus Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getComentarioTemporalRegistro(idRegistroEstatus: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getComentarioTemporalRegistro(idRegistroEstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los comentarios asociados a un registro
     * @param {number} idRegistro Identificador único del registro
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getComentariosRegistro(idRegistro: number, page?: number, size?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getComentariosRegistro(idRegistro, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener la informacion de los datos de actualizacion de una sede
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDatosActualizadosInstitucion(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDatosActualizadosInstitucion(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener la informacion de los datos de eliminacion de una subsede
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDatosEliminacionSubsede(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDatosEliminacionSubsede(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDatosGenerales(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDatosGenerales(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el documento de creacion
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDocumentoCreacion(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDocumentoCreacion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el documento del representante
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDocumentoRepresentante(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDocumentoRepresentante(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el documento de un registro de sede
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDocumentoSede(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDocumentoSede(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los documentos asociados a un registro (generales, representantes legales y subsdes)
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDocumentos(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDocumentos(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los documentos de anotaciones de incumplimiento
     * @param {number} idIncumplimiento ID del incumplimiento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDocumentosIncumplimiento(idIncumplimiento: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDocumentosIncumplimiento(idIncumplimiento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el domicilio de un residencial
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getDomicilioResidencial(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getDomicilioResidencial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el valor booleano en caso de tener o no un registro de persona física
     * @param {string} [cvu] cvu del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getExisteRegistrofisica(cvu?: string, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getExisteRegistrofisica(cvu, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el valor booleano en caso de existir o no un rfc
     * @param {string} rfc rfc del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getExisteRfc(rfc: string, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getExisteRfc(rfc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * obtiene las instituciones y subsedes de SNP
     * @param {string} [noDeRegistroQuery] Número de registro.
     * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
     * @param {string} [tipoSolicitud] ID del tipo de solicitud.
     * @param {string} [sector] Nombre del tipo de sector.
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener la lista de estatus de un registro
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getListaEstatus(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getListaEstatus(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los medios de contacto
     * @param {number} idPersona ID de la persona
     * @param {number} idRegistro ID del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getMediosContacto(idPersona: number, idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getMediosContacto(idPersona, idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene una persona basada en su ID
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getPersona(idPersona: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getPersona(idPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener a los representantes legales
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getPersonaRegistros(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getPersonaRegistros(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de plataformas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getPlataformas(options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getPlataformas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Método utilizado para recuperar el poder otorgado a una persona
     * @param {number} idPersona Identificador de la persona
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getPoderOtorgado(idPersona: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getPoderOtorgado(idPersona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de anotaciones de incumplimiento
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getRegistroAnotacion(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getRegistroAnotacion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener un registro de cancelación de incumplimiento por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getRegistroCancelacionIncumplimiento(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getRegistroCancelacionIncumplimiento(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener el domicilio de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getRegistroDomicilio(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getRegistroDomicilio(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de un CVU
     * @param {string} [cvu] cvu del usuario
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getRegistroSolicitudes(cvu?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getRegistroSolicitudes(cvu, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de anotaciones de incumplimiento
     * @param {string} [numeroOficio] Número de oficio.
     * @param {string} [numeroFolio] Número de folio.
     * @param {string} [cvuRepLegal] cvu del representante legal
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getRegistrosAnotaciones(numeroOficio?: string, numeroFolio?: string, cvuRepLegal?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getRegistrosAnotaciones(numeroOficio, numeroFolio, cvuRepLegal, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * obtiene registros del perfil del revisor según los parámetros de búsqueda proporcionados, como el RFC, el nombre de la empresa, el número de registro o el estado.
     * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
     * @param {string} [empresaInstitucionQuery] El nombre de la empresa o institución asociada a la solicitud.
     * @param {string} [noDeRegistroQuery] Número de registro.
     * @param {number} [estatusRegistroQuery] Estatus del registro.
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {number} [cvuRevisor] Cvu del revisor
     * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
     * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
     * @param {string} [cvuRepLegal] cvu del representante legal
     * @param {string} [nombreRepLegal] nombre del representante legal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getRegistrosRevisor(rfcQuery?: string, empresaInstitucionQuery?: string, noDeRegistroQuery?: string, estatusRegistroQuery?: number, page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, cvuRepLegal?: string, nombreRepLegal?: string, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getRegistrosRevisor(rfcQuery, empresaInstitucionQuery, noDeRegistroQuery, estatusRegistroQuery, page, size, cvuRevisor, misAsignaciones, esAdmin, cvuRepLegal, nombreRepLegal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exportar pdf registro
     * @param {number} idRegistro Identificador único del registro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getReporteRegistro(idRegistro: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getReporteRegistro(idRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtiene los reportes de PM
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getReportes(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getReportes(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los socios de un documento creación
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getSocios(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getSocios(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todas las subsedes de un registro
     * @param {number} idSede Identificador de la sede padre
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getSubsedes(idSede: number, page?: number, size?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getSubsedes(idSede, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todas las subsedes asociadas a un cvu
     * @param {string} cvu Cvu del usuario
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getSubsedesByCvu(cvu: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getSubsedesByCvu(cvu, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todas las subsedes
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {number} [cvuRevisor] Cvu del revisor
     * @param {boolean} [misAsignaciones] Bandera para saber si se mostraran las asignaciones de un revisor
     * @param {boolean} [esAdmin] Bandera para saber si el usuario es administrador
     * @param {string} [noRegistro] No de Registro de la subsede
     * @param {string} [empresaInstitucion] Empresa - Institucion de la subsede
     * @param {number} [estatus] Estatus de la subsede
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getSubsedesRevisor(page?: number, size?: number, cvuRevisor?: number, misAsignaciones?: boolean, esAdmin?: boolean, noRegistro?: string, empresaInstitucion?: string, estatus?: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getSubsedesRevisor(page, size, cvuRevisor, misAsignaciones, esAdmin, noRegistro, empresaInstitucion, estatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los registros de subsistemas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getSubsistemas(options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getSubsistemas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener todos los tipos de usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getTipoUsuario(options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getTipoUsuario(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupera el estado del job de jobrunr
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public getjobStatus(id: string, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).getjobStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Guarda el comentario temporal
     * @param {ComentarioRegistroEstatus} comentarioRegistroEstatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public guardarComentarioTemporal(comentarioRegistroEstatus: ComentarioRegistroEstatus, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).guardarComentarioTemporal(comentarioRegistroEstatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza la informacion de una persona
     * @param {number} id Identificador único
     * @param {Persona} persona 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public updatePersona(id: number, persona: Persona, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).updatePersona(id, persona, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actualiza un registro
     * @param {number} idRegistro Id del registro
     * @param {ActualizaRegistro} actualizaRegistro 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public updateRegistro(idRegistro: number, actualizaRegistro: ActualizaRegistro, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).updateRegistro(idRegistro, actualizaRegistro, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaDatosGenerales(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaDatosGenerales(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaDocumentoCreacion(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaDocumentoCreacion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaDocumentoRepresentante(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaDocumentoRepresentante(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaDocumentoSede(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaDocumentoSede(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaDomicilioRegistro(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaDomicilioRegistro(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaDomicilioResidencial(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaDomicilioResidencial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener los datos generales de un registro
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaPoderOtorgado(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaPoderOtorgado(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtener una lista de la validación de cada subsede
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReniecytApi
     */
    public validaSubsedes(id: number, options?: AxiosRequestConfig) {
        return ReniecytApiFp(this.configuration).validaSubsedes(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportesApi - axios parameter creator
 * @export
 */
export const ReportesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene los reportes de PM
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportes: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportes', 'id', id)
            const localVarPath = `/reportes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportesApi - functional programming interface
 * @export
 */
export const ReportesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportesApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtiene los reportes de PM
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportes(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportes(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportesApi - factory interface
 * @export
 */
export const ReportesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportesApiFp(configuration)
    return {
        /**
         * Obtiene los reportes de PM
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportes(id: number, options?: any): AxiosPromise<any> {
            return localVarFp.getReportes(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportesApi - object-oriented interface
 * @export
 * @class ReportesApi
 * @extends {BaseAPI}
 */
export class ReportesApi extends BaseAPI {
    /**
     * Obtiene los reportes de PM
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportesApi
     */
    public getReportes(id: number, options?: AxiosRequestConfig) {
        return ReportesApiFp(this.configuration).getReportes(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SectorApi - axios parameter creator
 * @export
 */
export const SectorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaSector: async (idRegistro: number, sector: Sector, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idRegistro' is not null or undefined
            assertParamExists('actualizaSector', 'idRegistro', idRegistro)
            // verify required parameter 'sector' is not null or undefined
            assertParamExists('actualizaSector', 'sector', sector)
            const localVarPath = `/registro/actualiza/sector/{idRegistro}`
                .replace(`{${"idRegistro"}}`, encodeURIComponent(String(idRegistro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sector, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectorApi - functional programming interface
 * @export
 */
export const SectorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SectorApiAxiosParamCreator(configuration)
    return {
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualizaSector(idRegistro: number, sector: Sector, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualizaSector(idRegistro, sector, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SectorApi - factory interface
 * @export
 */
export const SectorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SectorApiFp(configuration)
    return {
        /**
         * Actualiza La informacion que provenga del objeto sector.
         * @param {number} idRegistro Identificador único del registro
         * @param {Sector} sector 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualizaSector(idRegistro: number, sector: Sector, options?: any): AxiosPromise<void> {
            return localVarFp.actualizaSector(idRegistro, sector, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SectorApi - object-oriented interface
 * @export
 * @class SectorApi
 * @extends {BaseAPI}
 */
export class SectorApi extends BaseAPI {
    /**
     * Actualiza La informacion que provenga del objeto sector.
     * @param {number} idRegistro Identificador único del registro
     * @param {Sector} sector 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectorApi
     */
    public actualizaSector(idRegistro: number, sector: Sector, options?: AxiosRequestConfig) {
        return SectorApiFp(this.configuration).actualizaSector(idRegistro, sector, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SnpApi - axios parameter creator
 * @export
 */
export const SnpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitucionSnp: async (noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registro/snp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (noDeRegistroQuery !== undefined) {
                localVarQueryParameter['noDeRegistroQuery'] = noDeRegistroQuery;
            }

            if (rfcQuery !== undefined) {
                localVarQueryParameter['rfcQuery'] = rfcQuery;
            }

            if (tipoSolicitud !== undefined) {
                localVarQueryParameter['tipoSolicitud'] = tipoSolicitud;
            }

            if (sector !== undefined) {
                localVarQueryParameter['sector'] = sector;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SnpApi - functional programming interface
 * @export
 */
export const SnpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SnpApiAxiosParamCreator(configuration)
    return {
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InstitucionSnp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SnpApi - factory interface
 * @export
 */
export const SnpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SnpApiFp(configuration)
    return {
        /**
         * obtiene las instituciones y subsedes de SNP
         * @param {string} [noDeRegistroQuery] Número de registro.
         * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
         * @param {string} [tipoSolicitud] ID del tipo de solicitud.
         * @param {string} [sector] Nombre del tipo de sector.
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: any): AxiosPromise<Array<InstitucionSnp>> {
            return localVarFp.getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SnpApi - object-oriented interface
 * @export
 * @class SnpApi
 * @extends {BaseAPI}
 */
export class SnpApi extends BaseAPI {
    /**
     * obtiene las instituciones y subsedes de SNP
     * @param {string} [noDeRegistroQuery] Número de registro.
     * @param {string} [rfcQuery] RFC (Registro Federal de Contribuyentes)
     * @param {string} [tipoSolicitud] ID del tipo de solicitud.
     * @param {string} [sector] Nombre del tipo de sector.
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnpApi
     */
    public getInstitucionSnp(noDeRegistroQuery?: string, rfcQuery?: string, tipoSolicitud?: string, sector?: string, page?: number, size?: number, options?: AxiosRequestConfig) {
        return SnpApiFp(this.configuration).getInstitucionSnp(noDeRegistroQuery, rfcQuery, tipoSolicitud, sector, page, size, options).then((request) => request(this.axios, this.basePath));
    }
}


